import React, { useState, useEffect } from 'react';
import axios from 'axios';
import io from 'socket.io-client';
import API_CONFIG from './config/api';
import Sidebar from './Sidebar';
import NovaFicha from './NovaFicha';
import PreencherFicha from './PreencherFicha';
import Simulacoes from './Simulacoes';
import NovaSimulacao from './NovaSimulacao';
import EditarUsuario from './EditarUsuario';
import CadastrarVeiculoModal from './CadastrarVeiculoModalClean';
import Cobrancas from './Cobrancas';
import CalendarioCobrancasModal from './CalendarioCobrancasModal';
import AlterarLocalizacaoModal from './AlterarLocalizacaoModal';
import CadastrarFornecedorModal from './CadastrarFornecedorModal';
import JornadaVeiculoModal from './JornadaVeiculoModal';
import ModalFichas from './ModalFichas';
import ListaFichas from './ListaFichas';
import Negociacoes from './Negociacoes';
import Analise from './Analise';
import DocumentacaoKanban from './DocumentacaoKanban';
import ContasPagar from './ContasPagar';
import AcessosUsuarios from './AcessosUsuarios';
import { formatarDataInteligente, formatarDataSemHora } from './utils/formatarData';

const BANCOS_PADRAO = [
  { id: 'bancoSantander', nome: 'Santander' },
  { id: 'bancoItau', nome: 'Itau' },
  { id: 'bancoBancoVotorantim', nome: 'Banco Votorantim' },
  { id: 'bancoPAN', nome: 'Banco PAN' },
  { id: 'bancoC6', nome: 'Banco C6' },
  { id: 'bancoBradescoAntigo', nome: 'Bradesco (Antigo)' },
  { id: 'bancoBradescoNovo', nome: 'Bradesco (Novo)' },
  { id: 'bancoBancoSafra', nome: 'Banco Safra' },
  { id: 'bancoBBC', nome: 'BBC' },
  { id: 'bancoFinamax', nome: 'Finamax' },
  { id: 'bancoOmni', nome: 'Omni' },
  { id: 'bancoDaycoval', nome: 'Daycoval' },
  { id: 'bancoVolkswagen', nome: 'Volkswagen' },
  { id: 'bancoCreditas', nome: 'Creditas' },
  { id: 'bancoSimpala', nome: 'Simpala' }
];

const Dashboard = ({ user: usuarioInicial, onLogout }) => {
  const [user, setUser] = useState(usuarioInicial);
  const atualizarAcessos = async () => {
    try {
      const { data } = await axios.get(`${API_CONFIG.API_URL}/acessos/me`, { headers: { 'x-auth-token': localStorage.getItem('token') } });
      setUser(anterior => ({ ...anterior, menus_efetivos: data.menus, gerenciar_acessos: data.gerenciar }));
    } catch (_) { /* O servidor continua bloqueando acessos revogados. */ }
  };
  useEffect(() => {
    atualizarAcessos();
    const intervalo = setInterval(atualizarAcessos, 30000);
    window.addEventListener('focus', atualizarAcessos);
    return () => { clearInterval(intervalo); window.removeEventListener('focus', atualizarAcessos); };
  }, []);
  const [lojaContexto, setLojaContexto] = useState(null);

  useEffect(() => {
    const savedContext = localStorage.getItem('lojaContexto');
    if (savedContext) {
      try {
        const parsed = JSON.parse(savedContext);
        setLojaContexto(parsed);
      } catch (e) {
        localStorage.removeItem('lojaContexto');
      }
    }
  }, []);

  // Configurar interceptor Axios para contexto de loja
  useEffect(() => {
    if (!lojaContexto) return;

    const requestInterceptor = axios.interceptors.request.use((config) => {
      config.headers['x-loja-id'] = lojaContexto.id;
      return config;
    });

    return () => {
      axios.interceptors.request.eject(requestInterceptor);
    };
  }, [lojaContexto]);

  const iaEstadoInicial = {
    aberto: false,
    titulo: '',
    conteudo: '',
    loading: false,
    erro: false,
    tipo: 'apresentacao',
    modeloComparacao: '',
    veiculo: null
  };

  const [activeMenu, setActiveMenu] = useState(() =>
    String(user?.cargo || user?.tipo || '').toLowerCase() === 'financeiro'
      ? 'financeiro_contas'
      : 'fichas'
  );
  const [analiseSubmenu, setAnaliseSubmenu] = useState(null);
  const [negociacaoOrigemId, setNegociacaoOrigemId] = useState(null);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [fichas, setFichas] = useState([]);
  const [simulacoes, setSimulacoes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [statusFilter, setStatusFilter] = useState('Todos os Status');
  const [filtrosFichasAbertos, setFiltrosFichasAbertos] = useState(false);
  const [stats, setStats] = useState(null);
  const [showNovaFicha, setShowNovaFicha] = useState(false);
  const [showModalFichas, setShowModalFichas] = useState(false);
  const [voltarParaModalFichas, setVoltarParaModalFichas] = useState(false);
  const [message, setMessage] = useState(null);
  const [fichaParaPreencher, setFichaParaPreencher] = useState(null);
  const [fichaParaSimulacao, setFichaParaSimulacao] = useState(null);

  const [paginaAtual, setPaginaAtual] = useState(1);
  const [itensPorPagina] = useState(10);
  const [paginaFichas, setPaginaFichas] = useState(1);
  const [paginaVeiculos, setPaginaVeiculos] = useState(1);
  const [paginaUsuarios, setPaginaUsuarios] = useState(1);
  const [paginaSimulacoes, setPaginaSimulacoes] = useState(1);

  const [veiculos, setVeiculos] = useState([]);
  const [loadingVeiculos, setLoadingVeiculos] = useState(false);
  const [searchVeiculos, setSearchVeiculos] = useState('');
  const [statusVeiculoFilter, setStatusVeiculoFilter] = useState('Todos');
  const [tipoVeiculoFilter, setTipoVeiculoFilter] = useState('Todos');
  const [showFiltrosVeiculos, setShowFiltrosVeiculos] = useState(false);
  
  useEffect(() => {
    setVeiculosSelecionados((prev) => prev.filter((id) => veiculos.some((v) => v && v._id === id)));
  }, [veiculos]);

  const [usuarios, setUsuarios] = useState([]);
  const [loadingUsuarios, setLoadingUsuarios] = useState(false);
  const [searchUsuarios, setSearchUsuarios] = useState('');
  const [usuarioParaEditar, setUsuarioParaEditar] = useState(null);
  const [usuarioAcessosId, setUsuarioAcessosId] = useState(null);
  const [showBpsModal, setShowBpsModal] = useState(false);
  const [formBps, setFormBps] = useState({ usuario: '', senha: '' });
  const [salvandoBps, setSalvandoBps] = useState(false);

  const [showCadastrarVeiculo, setShowCadastrarVeiculo] = useState(false);
  const [veiculoParaEditar, setVeiculoParaEditar] = useState(null);
  const [showAlterarLocalizacao, setShowAlterarLocalizacao] = useState(false);
  const [veiculoParaMovimentar, setVeiculoParaMovimentar] = useState(null);
  const [ordenarPor, setOrdenarPor] = useState('veiculo');
  const [ordem, setOrdem] = useState('asc');
  const [showNovaSimulacao, setShowNovaSimulacao] = useState(false);
  const [veiculosSelecionados, setVeiculosSelecionados] = useState([]);

  const [notificacoes, setNotificacoes] = useState([]);
  const [contadorNotificacoes, setContadorNotificacoes] = useState(0);
  const [showNotificacoes, setShowNotificacoes] = useState(false);

  const [showCadastrarFornecedor, setShowCadastrarFornecedor] = useState(false);
  const [fornecedorParaEditar, setFornecedorParaEditar] = useState(null);
  const [fornecedores, setFornecedores] = useState([]);

  const [showJornada, setShowJornada] = useState(false);
  const [veiculoJornadaId, setVeiculoJornadaId] = useState(null);

  const [showHistoricoRemovidos, setShowHistoricoRemovidos] = useState(false);
  const [veiculosRemovidos, setVeiculosRemovidos] = useState([]);
  const [loadingRemovidos, setLoadingRemovidos] = useState(false);
  const [searchRemovidos, setSearchRemovidos] = useState('');

  const [dropdownFichaAberto, setDropdownFichaAberto] = useState(null);
  const [veiculoHoverId, setVeiculoHoverId] = useState(null);
  const [loadingSync, setLoadingSync] = useState(false);
  const [localGap, setLocalGap] = useState('');
  const [gapSavingSuccess, setGapSavingSuccess] = useState(false);
  const [ultimaSyncEstoque, setUltimaSyncEstoque] = useState(null);
  const [loadingStatusSync, setLoadingStatusSync] = useState(false);

  const [bancos, setBancos] = useState([]);
  const [showModalBanco, setShowModalBanco] = useState(false);
  const [showTabelaBancosReferencia, setShowTabelaBancosReferencia] = useState(false);
  const [bancoEditando, setBancoEditando] = useState(null);
  const [formBanco, setFormBanco] = useState({ nome: '', codigo_banco: '', acessos: [] });
  const [mostrarSenhaBanco, setMostrarSenhaBanco] = useState(false);
  const [configSubmenu, setConfigSubmenu] = useState(null);
  const [ocultarNomesBancos, setOcultarNomesBancos] = useState(false);
  const lojaEhPremiumBeef = (lojaContexto?.codigo || lojaContexto?.nome || '').toString().toLowerCase().includes('premium beef');

  useEffect(() => {
    const abrirUsuariosPremiumBeef = localStorage.getItem('premiumBeefOpenUsers') === '1';
    if (abrirUsuariosPremiumBeef && lojaEhPremiumBeef) {
      setActiveMenu('configuracoes');
      setConfigSubmenu('usuarios');
      localStorage.removeItem('premiumBeefOpenUsers');
    }
  }, [lojaEhPremiumBeef]);

  // Calcular isVendedor uma única vez no escopo do componente
  const isVendedor = (user?.cargo || '').toLowerCase() === 'vendedor';
  useEffect(() => {
    if (user?.tipo === 'super_admin' || !Array.isArray(user?.menus_efetivos)) return;
    const menu = ({ inicio: 'fichas', simulacoes: 'fichas', usuarios: 'configuracoes' })[activeMenu] || activeMenu;
    if (activeMenu === 'acessos' && user.gerenciar_acessos) {
      setConfigSubmenu('usuarios'); setActiveMenu('configuracoes'); return;
    }
    if (activeMenu === 'configuracoes' && user.gerenciar_acessos) return;
    if (!user.menus_efetivos.includes(menu)) setActiveMenu(user.menus_efetivos[0] || (user.gerenciar_acessos ? 'configuracoes' : 'sem_acesso'));
  }, [user, activeMenu]);

  // Inicializar preferências do usuário ao carregar
  useEffect(() => {
    if (user?.permissoes?.configuracoes_pessoais) {
      if (user.permissoes.configuracoes_pessoais.gap_parcela !== undefined) {
          setLocalGap(user.permissoes.configuracoes_pessoais.gap_parcela);
      }
      if (user.permissoes.configuracoes_pessoais.ocultarNomesBancos !== undefined) {
          setOcultarNomesBancos(user.permissoes.configuracoes_pessoais.ocultarNomesBancos);
      }
    }
  }, [user]);

  // Abrir primeira aba disponível ao navegar para Configurações
  useEffect(() => {
    if (activeMenu === 'configuracoes') {
      // Se configSubmenu já está definido e é válido, manter a seleção atual
      if (configSubmenu) {
        // Verificar se a aba atual ainda é válida para este usuário
        const abasDisponiveis = isVendedor 
          ? ['simulacoes'] 
          : ['usuarios', 'bancos', 'fornecedores', 'whatsapp', 'estoque', 'simulacoes'];
        
        if (abasDisponiveis.includes(configSubmenu)) {
          return; // Manter aba atual
        }
      }

      // Se não há aba ou é inválida, selecionar a primeira disponível
      const primeiraAba = isVendedor ? 'simulacoes' : 'usuarios';
      setConfigSubmenu(primeiraAba);
    }
  }, [activeMenu, isVendedor]);

  const [searchCobrancas, setSearchCobrancas] = useState('');
  const [showCadastrarCobranca, setShowCadastrarCobranca] = useState(false);
  const [showCalendarModal, setShowCalendarModal] = useState(false);
  const [cobrancas, setCobrancas] = useState([]);

  const [whatsappStatus, setWhatsappStatus] = useState(null);
  const [whatsappQR, setWhatsappQR] = useState(null);
  const [whatsappInfo, setWhatsappInfo] = useState(null);

  const [iaModal, setIaModal] = useState(iaEstadoInicial);

  // Auto-remover mensagem após 3 segundos
  useEffect(() => {
    if (message) {
      const timer = setTimeout(() => setMessage(null), 3000);
      return () => clearTimeout(timer);
    }
  }, [message]);

  // Conectar WebSocket para notificações em tempo real
  useEffect(() => {
    if (!user || !user.id) return;

    const socket = io(API_CONFIG.API_URL.replace('/api', ''), {
      transports: ['websocket', 'polling'],
      reconnection: true,
      reconnectionDelay: 1000,
      reconnectionAttempts: 5
    });

    socket.on('connect', () => {
      // Autenticar usuário no socket
      socket.emit('authenticate', user.id);
    });

    // Escutar notificações em tempo real
    socket.on('nova-notificacao', (notificacao) => {
      
      // Adicionar notificação à lista
      setNotificacoes(prev => [notificacao, ...prev]);
      
      // Incrementar contador
      setContadorNotificacoes(prev => prev + 1);
      
      // Reproduzir som de notificação (opcional)
      try {
        const audio = new Audio('data:audio/wav;base64,UklGRnoGAABXQVZFZm10IBAAAAABAAEAQB8AAEAfAAABAAgAZGF0YQoGAACBhYqFbF1fdJivrJBhNjVgodDbq2EcBj+a2/LDciUFLIHO8tiJNwgZaLvt559NEAxQp+PwtmMcBjiR1/LMeSwFJHfH8N2QQAoUXrTp66hVFApGn+DyvmwhBTGH0fPTgjMGHm7A7+OZRA0PVant6qxbGAxJouHzvG0gBSyB0PPchzEHImXE7eCVPA==');
        audio.volume = 0.3;
        audio.play().catch(() => {}); // Ignorar erros de autoplay
      } catch (error) {
      }
    });

    socket.on('atualizar-simulacao', (simulacaoAtualizada) => {
      setSimulacoes(prev => {
        const index = prev.findIndex(s => s._id === simulacaoAtualizada._id);
        if (index === -1) return [simulacaoAtualizada, ...prev];
        const novaLista = [...prev];
        novaLista[index] = simulacaoAtualizada;
        return novaLista;
      });
    });

    socket.on('ficha-atualizada', (dados) => {
      setFichas(prev => {
        const index = prev.findIndex(f => f._id === dados._id);
        if (index === -1) return prev;
        const novaLista = [...prev];
        novaLista[index] = { 
          ...novaLista[index], 
          status: dados.status || novaLista[index].status,
          clienteNaLoja: dados.clienteNaLoja !== undefined ? dados.clienteNaLoja : novaLista[index].clienteNaLoja
        };
        return novaLista;
      });
    });

    socket.on('disconnect', () => {
    });

    socket.on('connect_error', (error) => {
    });

    return () => {
      socket.disconnect();
    };
  }, [user]);

  // Fechar dropdown ao clicar fora
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownFichaAberto && !event.target.closest('.btn-dropdown-container')) {
        setDropdownFichaAberto(null);
      }
    };

    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, [dropdownFichaAberto]);

  // Fechar notificações ao clicar fora
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (showNotificacoes && !event.target.closest('.notificacoes-floating')) {
        setShowNotificacoes(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [showNotificacoes]);

  const carregarNotificacoes = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`${API_CONFIG.API_URL}/notificacoes?limit=20`, {
        headers: { 'x-auth-token': token }
      });
      
      if (response.data.success) {
        setNotificacoes(response.data.data);
        setContadorNotificacoes(response.data.naoLidas);
      }
    } catch (error) {
    }
  };

  const carregarContadorNotificacoes = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`${API_CONFIG.API_URL}/notificacoes/contador`, {
        headers: { 'x-auth-token': token }
      });
      
      if (response.data.success) {
        setContadorNotificacoes(response.data.naoLidas);
      }
    } catch (error) {
    }
  };

  const marcarComoLida = async (notificacaoId) => {
    try {
      const token = localStorage.getItem('token');
      await axios.put(`${API_CONFIG.API_URL}/notificacoes/${notificacaoId}/marcar-lida`, {}, {
        headers: { 'x-auth-token': token }
      });
      
      await carregarNotificacoes();
      await carregarContadorNotificacoes();
    } catch (error) {
    }
  };

  const marcarTodasLidas = async () => {
    try {
      
      const token = localStorage.getItem('token');
      
      const response = await axios.put(`${API_CONFIG.API_URL}/notificacoes/marcar-todas-lidas`, {}, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      
      
      await carregarNotificacoes();
      setContadorNotificacoes(0);
    } catch (error) {
    }
  };

  const excluirNotificacao = async (notificacaoId) => {
    try {
      const token = localStorage.getItem('token');
      await axios.delete(`${API_CONFIG.API_URL}/notificacoes/${notificacaoId}`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      
      await carregarNotificacoes();
      await carregarContadorNotificacoes();
      
      setMessage({ type: 'success', text: 'Notificação excluída' });
    } catch (error) {
      setMessage({ type: 'error', text: 'Erro ao excluir notificação' });
    }
  };

  // Carregar contador de notificações ao iniciar
  useEffect(() => {
    carregarContadorNotificacoes();
  }, []);

  // Carregar fichas do MongoDB
  const carregarFichas = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`${API_CONFIG.API_URL}/fichas`, {
        headers: { 'x-auth-token': token },
        params: {
          search: searchTerm,
          status: statusFilter,
          page: 1,
          limit: searchTerm ? 300 : 50
        }
      });

      if (response.data.success) {
        setFichas(response.data.data || []);
      } else {
        setFichas([]);
      }
    } catch (error) {
      setFichas([]);
    } finally {
      setLoading(false);
    }
  };

  // Carregar simulações do MongoDB
  const carregarSimulacoes = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`${API_CONFIG.API_URL}/simulacoes`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      
      if (response.data.success) {
        const listaSimulacoes = Array.isArray(response.data.data) ? response.data.data : [];
        
        // Regras de Ordenação:
        // PENDENTES e EM ANÁLISE: Cliente na loja primeiro, depois mais antigas primeiro.
        // FINALIZADAS: Mais recente primeiro para mais antiga por último.
        
        const simulacoesOrdenadas = listaSimulacoes.sort((a, b) => {
          // 1. Separar por status para aplicar lógicas diferentes se necessário
          const isFinalizadaA = a.status === 'Finalizada';
          const isFinalizadaB = b.status === 'Finalizada';

          // Se um é finalizada e o outro não, não alteramos a ordem relativa aqui (o filtro de status cuida disso na visualização se houver)
          // Mas como a lista pode ser mista ou filtrada, aplicamos as regras específicas:

          if (isFinalizadaA && isFinalizadaB) {
            // Regra FINALIZADAS: Mais recente primeiro
            return new Date(b.createdAt) - new Date(a.createdAt);
          } else if (!isFinalizadaA && !isFinalizadaB) {
            // Regra PENDENTES / EM ANÁLISE: Mais antigas primeiro (createdAt ASC)
            return new Date(a.createdAt) - new Date(b.createdAt);
          }

          // Se forem de categorias diferentes, mantém a ordem por data de criação (mais antiga primeiro como padrão)
          return new Date(a.createdAt) - new Date(b.createdAt);
        });
        
        setSimulacoes(simulacoesOrdenadas);
      } else {
        setSimulacoes([]);
      }
    } catch (error) {
      setSimulacoes([]);
      if (error.response && error.response.status === 401) {
        onLogout();
      }
    } finally {
      setLoading(false);
    }
  };

  // Carregar estatísticas
  const carregarEstatisticas = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`${API_CONFIG.API_URL}/fichas/stats/resumo`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      if (response.data.success) {
        setStats(response.data.data || { total: 0, porStatus: [] });
      } else {
        setStats({ total: 0, porStatus: [] });
      }
    } catch (error) {
      setStats({ total: 0, porStatus: [] }); // Garantir estrutura padrão
    }
  };

  const abrirJornada = (veiculoId) => {
    setVeiculoJornadaId(veiculoId);
    setShowJornada(true);
    setShowAlterarLocalizacao(false); // Fechar modal de alterar localização se aberto
    setShowCadastrarVeiculo(false); // Fechar modal de editar veículo se aberto
  };

  const carregarFornecedores = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`${API_CONFIG.API_URL}/fornecedores`, {
        headers: { 'x-auth-token': token }
      });
      if (response.data.success) {
        setFornecedores(response.data.data || []);
      }
    } catch (error) {
    }
  };

  // Gerar link público para preenchimento de ficha

  // Carregar dados quando a seção de fichas for ativa ou no início
  useEffect(() => {
    if (activeMenu === 'fichas' || activeMenu === 'inicio') {
      carregarFichas();
    }
    if (activeMenu === 'simulacoes') {
      carregarSimulacoes();
    }
  }, [activeMenu, searchTerm, statusFilter, lojaContexto]);

  // Carregar estatísticas no início
  useEffect(() => {
    carregarEstatisticas();
  }, [lojaContexto]);


  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleStatusFilter = (e) => {
    setStatusFilter(e.target.value);
  };

  // Carregar veículos
  const carregarVeiculos = async () => {
    setLoadingVeiculos(true);
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`${API_CONFIG.API_URL}/veiculos`, {
        headers: {
          'x-auth-token': token
        },
        params: {
          search: searchVeiculos
        }
      });
      
      
      if (response.data.success) {
        const veiculosData = Array.isArray(response.data.data) ? response.data.data : [];
        
        // Testar comparação
        if (veiculosData[0]?.seguidores && veiculosData[0].seguidores.length > 0 && user?.id) {
          const seg = veiculosData[0].seguidores[0];
        }
        
        setVeiculos(veiculosData);
      } else {
        setVeiculos([]);
      }
    } catch (error) {
      setVeiculos([]);
      if (error.response && error.response.status === 401) {
        onLogout();
      }
    } finally {
      setLoadingVeiculos(false);
    }
  };

  const carregarStatusSync = async () => {
    setLoadingStatusSync(true);
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`${API_CONFIG.API_URL}/veiculos/sincronizar/status`, {
        headers: { 'x-auth-token': token }
      });

      if (response.data.success) {
        setUltimaSyncEstoque(response.data.ultimaSincronizacao || null);
      } else {
        setUltimaSyncEstoque(null);
      }
    } catch (error) {
      console.error('Erro ao carregar status de sincronização:', error);
      setUltimaSyncEstoque(null);
    } finally {
      setLoadingStatusSync(false);
    }
  };

  const handleSincronizar = async () => {
    setLoadingSync(true);
    try {
      const token = localStorage.getItem('token');
      const response = await axios.post(
        `${API_CONFIG.API_URL}/veiculos/sincronizar`,
        {},
        { headers: { 'x-auth-token': token } }
      );

      if (response.data.success) {
        setMessage({
          type: 'success',
          text: response.data.message || 'Estoque sincronizado com sucesso!'
        });
        await carregarStatusSync();
        await carregarVeiculos();
      } else {
        setMessage({
          type: 'error',
          text: response.data.message || 'Erro ao sincronizar estoque'
        });
      }
    } catch (error) {
      console.error('Erro ao sincronizar estoque:', error);
      setMessage({
        type: 'error',
        text: error.response?.data?.message || 'Erro ao sincronizar estoque'
      });
    } finally {
      setLoadingSync(false);
    }
  };

  // Carregar veículos removidos com filtro
  const carregarRemovidos = async (placa = '') => {
    setLoadingRemovidos(true);
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`${API_CONFIG.API_URL}/veiculos/removidos/historico`, {
        headers: { 'x-auth-token': token },
        params: placa ? { search: placa } : {}
      });

      if (response.data.success) {
        setVeiculosRemovidos(response.data.data || []);
      } else {
        setVeiculosRemovidos([]);
      }
    } catch (error) {
      console.error('Erro ao carregar veículos removidos:', error);
      setVeiculosRemovidos([]);
    } finally {
      setLoadingRemovidos(false);
    }
  };

  // Restaurar veículo removido
  const restaurarVeiculo = async (veiculoId) => {
    if (!window.confirm('Tem certeza que deseja restaurar este veículo?')) {
      return;
    }

    try {
      const token = localStorage.getItem('token');
      const response = await axios.post(
        `${API_CONFIG.API_URL}/veiculos/${veiculoId}/restaurar`,
        {},
        { headers: { 'x-auth-token': token } }
      );

      if (response.data.success) {
        setMessage({ type: 'success', text: 'Veículo restaurado com sucesso!' });
        carregarRemovidos(searchRemovidos); // Recarregar lista
      } else {
        setMessage({ type: 'error', text: response.data.message || 'Erro ao restaurar' });
      }
    } catch (error) {
      setMessage({ type: 'error', text: 'Erro ao restaurar veículo' });
    }
  };

  // Excluir veículo
  const excluirVeiculo = async (veiculoId) => {
    if (!window.confirm('Tem certeza que deseja excluir este veículo do estoque?')) {
      return;
    }

    try {
      const token = localStorage.getItem('token');
      const response = await axios.delete(`${API_CONFIG.API_URL}/veiculos/${veiculoId}`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      if (response.data.success) {
        setMessage({ type: 'success', text: 'Veículo excluído com sucesso!' });
        carregarVeiculos(); // Recarregar lista
      } else {
        setMessage({ type: 'error', text: response.data.message || 'Erro ao excluir veículo' });
      }
    } catch (error) {
      setMessage({ 
        type: 'error', 
        text: error.response?.data?.message || 'Erro ao excluir veículo. Tente novamente.' 
      });
    }
  };

  const [carregandoFipe, setCarregandoFipe] = useState(null);
  const [fipeInput, setFipeInput] = useState('');
  const [veiculoEditandoFipe, setVeiculoEditandoFipe] = useState(null);

  // Atualizar FIPE manualmente
  const atualizarFipeVeiculo = async (veiculoId, valor) => {
    try {
      if (!valor || isNaN(valor) || valor < 0) {
        setMessage({ 
          type: 'error', 
          text: 'Valor FIPE inválido' 
        });
        return;
      }

      setCarregandoFipe(veiculoId);
      const token = localStorage.getItem('token');
      
      const response = await axios.post(
        `${API_CONFIG.API_URL}/veiculos/${veiculoId}/fipe-manual`,
        { fipe_valor: parseFloat(valor) },
        {
          headers: { 'x-auth-token': token },
          timeout: 10000
        }
      );

      if (response.data.success) {
        setMessage({ 
          type: 'success', 
          text: `✅ FIPE atualizado: R$ ${parseFloat(valor).toLocaleString('pt-BR', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}` 
        });
        setFipeInput('');
        setVeiculoEditandoFipe(null);
        carregarVeiculos(); // Recarregar lista
      } else {
        setMessage({ 
          type: 'error', 
          text: response.data.message || 'Erro ao atualizar FIPE' 
        });
      }
    } catch (error) {
      setMessage({ 
        type: 'error', 
        text: error.response?.data?.message || 'Erro ao salvar FIPE' 
      });
    } finally {
      setCarregandoFipe(null);
    }
  };

  // Função para seguir/deixar de seguir veículo
  const toggleSeguirVeiculo = async (veiculoId, e) => {
    if (e) e.stopPropagation();
    
    try {
      const token = localStorage.getItem('token');
      const response = await axios.post(
        `${API_CONFIG.API_URL}/veiculos/${veiculoId}/seguir`,
        {},
        {
          headers: { 'x-auth-token': token }
        }
      );

      if (response.data.success) {
        
        // Recarregar lista de veículos do servidor para garantir persistência
        await carregarVeiculos();
        
        // Atualizar veiculoParaEditar se for o veículo sendo editado
        if (veiculoParaEditar && veiculoParaEditar._id === veiculoId) {
          const veiculoAtualizado = veiculos.find(v => v._id === veiculoId);
          if (veiculoAtualizado) {
            setVeiculoParaEditar(veiculoAtualizado);
          }
        }
      }
    } catch (error) {
    }
  };

  // Imprimir estoque separado por loja
  const imprimirEstoque = async () => {
    try {
      // Recarregar veículos do servidor antes de imprimir para garantir dados atualizados
      setLoading(true);
      const token = localStorage.getItem('token');
      const response = await axios.get(`${API_CONFIG.API_URL}/veiculos`, {
        headers: { 'x-auth-token': token }
      });

      let veiculosAtualizados = [];
      if (response.data.success) {
        veiculosAtualizados = response.data.data || response.data.veiculos || [];
      }
      
      setLoading(false);

      // Aplicar os mesmos filtros da tela principal
      const veiculosFiltrados = veiculosAtualizados.filter(veiculo => {
        if (!veiculo || !veiculo._id) return false;
        
        // Filtro por status (mesmo da tela principal)
        if (statusVeiculoFilter !== 'Todos' && veiculo.status !== statusVeiculoFilter) {
          return false;
        }
        
        // Filtro por tipo (repasse)
        if (tipoVeiculoFilter !== 'Todos') {
          if (tipoVeiculoFilter === 'Repasse' && !veiculo.tipo?.includes('Repasse')) {
            return false;
          }
          if (tipoVeiculoFilter === 'Venda normal' && veiculo.tipo !== 'Venda normal') {
            return false;
          }
        }
        
        // Filtro por busca (se houver) - busca flexível em qualquer parte do texto
        if (searchVeiculos) {
          const search = searchVeiculos.toLowerCase().trim();
          const termosBusca = search.split(/\s+/).filter(t => t.length > 0);

          // Combinar todos os campos de busca em um único texto
          const textoCompleto = [
            veiculo.marca || '',
            veiculo.modelo || '',
            veiculo.placa || '',
            veiculo.cor || '',
            veiculo.combustivel || '',
            veiculo.cambio || ''
          ].join(' ').toLowerCase();

          // Verificar se TODOS os termos de busca estão presentes no texto completo
          const todosTermosEncontrados = termosBusca.every(termo =>
            textoCompleto.includes(termo)
          );

          if (!todosTermosEncontrados) {
            return false;
          }
        }
        
        return true;
      });
      
      // Agrupar veículos por loja
      const veiculosPorLoja = veiculosFiltrados.reduce((acc, veiculo) => {
      const lojaNome = veiculo.localizacao || 'Sem Localização';
      if (!acc[lojaNome]) {
        acc[lojaNome] = [];
      }
      acc[lojaNome].push(veiculo);
      return acc;
    }, {});

    // Criar janela de impressão
    const printWindow = window.open('', '_blank');
    
    // Data atual
    const dataAtual = new Date().toLocaleDateString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });

    // Montar texto dos filtros ativos
    let filtrosAtivos = [];
    
    if (statusVeiculoFilter !== 'Todos') {
      filtrosAtivos.push(`Status: ${statusVeiculoFilter}`);
    }
    
    if (tipoVeiculoFilter !== 'Todos') {
      filtrosAtivos.push(`Tipo: ${tipoVeiculoFilter}`);
    }
    
    if (searchVeiculos) {
      filtrosAtivos.push(`Busca: "${searchVeiculos}"`);
    }
    
    const textoFiltros = filtrosAtivos.length > 0 
      ? `Filtros aplicados: ${filtrosAtivos.join(' | ')}` 
      : 'Todos os veículos';

    // Montar HTML
    let html = `
      <!DOCTYPE html>
      <html>
      <head>
        <title>Estoque de Veículos - ${dataAtual}</title>
        <meta charset="utf-8">
        <style>
          * {
            margin: 0;
            padding: 0;
            box-sizing: border-box;
          }
          
          body {
            font-family: Arial, sans-serif;
            padding: 20px;
            font-size: 10px;
            line-height: 1.3;
          }
          
          .header {
            text-align: center;
            margin-bottom: 30px;
            padding-bottom: 15px;
            border-bottom: 3px solid #2c3e50;
          }
          
          .header h1 {
            font-size: 18px;
            color: #2c3e50;
            margin-bottom: 8px;
          }
          
          .header .info {
            font-size: 10px;
            color: #666;
            margin-bottom: 5px;
          }
          
          .header .filtros {
            font-size: 10px;
            color: #3498db;
            font-weight: 600;
            margin-top: 8px;
            padding: 6px 12px;
            background: #ecf0f1;
            border-radius: 4px;
            display: inline-block;
          }
          
          .loja-section {
            margin-bottom: 40px;
            page-break-inside: avoid;
          }
          
          .loja-header {
            background: linear-gradient(135deg, #3498db 0%, #2980b9 100%);
            color: white;
            padding: 10px 15px;
            margin-bottom: 15px;
            border-radius: 5px;
            display: flex;
            justify-content: space-between;
            align-items: center;
          }
          
          .loja-header h2 {
            font-size: 14px;
            font-weight: 600;
          }
          
          .loja-header .count {
            background: rgba(255,255,255,0.2);
            padding: 3px 10px;
            border-radius: 20px;
            font-size: 11px;
            font-weight: bold;
          }
          
          table {
            width: 100%;
            border-collapse: collapse;
            margin-bottom: 20px;
            background: white;
          }
          
          th {
            background: #ecf0f1;
            color: #2c3e50;
            padding: 8px 6px;
            text-align: left;
            font-weight: 600;
            font-size: 10px;
            border: 1px solid #bdc3c7;
          }
          
          td {
            padding: 6px 5px;
            border: 1px solid #ddd;
            font-size: 10px;
          }
          
          tr:nth-child(even) {
            background-color: #f9f9f9;
          }
          
          tr:hover {
            background-color: #f0f0f0;
          }
          
          .status {
            display: inline-block;
            padding: 2px 6px;
            border-radius: 10px;
            font-size: 9px;
            font-weight: 600;
            white-space: nowrap;
          }
          
          .status.disponivel {
            background: #d4edda;
            color: #155724;
          }
          
          .status.vendido {
            background: #f8d7da;
            color: #721c24;
          }
          
          .status.reservado {
            background: #fff3cd;
            color: #856404;
          }
          
          .footer {
            margin-top: 30px;
            padding-top: 15px;
            border-top: 2px solid #ddd;
            text-align: center;
            font-size: 9px;
            color: #666;
          }
          
          .total-geral {
            background: #2c3e50;
            color: white;
            padding: 12px;
            margin-top: 20px;
            border-radius: 5px;
            text-align: center;
            font-size: 14px;
            font-weight: bold;
          }
          
          @media print {
            body {
              padding: 10px;
            }
            
            .loja-section {
              page-break-inside: avoid;
            }
            
            tr {
              page-break-inside: avoid;
            }
          }
        </style>
      </head>
      <body>
        <div class="header">
          <h1>Relatório de Estoque</h1>
          <div class="info">${dataAtual}</div>
          <div class="filtros">${textoFiltros}</div>
        </div>
    `;

    // Adicionar seção para cada loja
    const lojas = Object.keys(veiculosPorLoja).sort();
    let totalGeral = 0;

    lojas.forEach(lojaNome => {
      const veiculosLoja = veiculosPorLoja[lojaNome];
      totalGeral += veiculosLoja.length;

      html += `
        <div class="loja-section">
          <div class="loja-header">
            <h2> ${lojaNome}</h2>
            <span class="count">${veiculosLoja.length} veículo(s)</span>
          </div>
          
          <table>
            <thead>
              <tr>
                <th style="width: 40%">Veículo</th>
                <th style="width: 10%">Placa</th>
                <th style="width: 7%">Ano</th>
                <th style="width: 12%">KM</th>
                <th style="width: 21%">Valor</th>
                <th style="width: 10%">Anunciado</th>
              </tr>
            </thead>
            <tbody>
      `;

      veiculosLoja.forEach((veiculo, index) => {
        // Tentar diferentes campos de valor (mesma lógica da tabela principal)
        const valor = veiculo.preco_venda || veiculo.preco || veiculo.valor_venda || veiculo.valor || 0;
        const valorFormatado = valor > 0
          ? `R$ ${parseFloat(valor).toLocaleString('pt-BR', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}` 
          : 'R$ 0';
        
        const kmFormatado = veiculo.km ? parseInt(veiculo.km).toLocaleString('pt-BR') : '0';
        
        // Ano no formato reduzido (apenas 2 dígitos)
        const anoFormatado = veiculo.ano_fabricacao && veiculo.ano_modelo 
          ? `${String(veiculo.ano_fabricacao).slice(-2)}/${String(veiculo.ano_modelo).slice(-2)}`
          : veiculo.ano_modelo 
            ? String(veiculo.ano_modelo).slice(-2)
            : veiculo.ano 
              ? String(veiculo.ano).slice(-2)
              : '-';

        html += `
          <tr>
            <td><strong>${veiculo.marca} ${veiculo.modelo}</strong></td>
            <td>${veiculo.placa ? veiculo.placa.replace(/-/g, '') : '-'}</td>
            <td style="text-align: center;">${anoFormatado}</td>
            <td>${kmFormatado}</td>
            <td><strong>${valorFormatado}</strong></td>
            <td style="text-align: center;">?</td>
          </tr>
        `;
      });

      html += `
            </tbody>
          </table>
        </div>
      `;
    });

    html += `
        <div class="total-geral">
          TOTAL GERAL: ${totalGeral} VEÍCULO(S) EM ESTOQUE
        </div>
        
        <div class="footer">
          Relatório gerado automaticamente pelo sistema em ${dataAtual}
        </div>
        
        <script>
          // Aguardar o DOM carregar completamente antes de imprimir
          window.onload = function() {
            setTimeout(function() {
              window.print();
            }, 500);
          };
        </script>
      </body>
      </html>
    `;

    printWindow.document.write(html);
    printWindow.document.close();
    
    } catch (error) {
      setLoading(false);
      setMessage({ 
        type: 'error', 
        text: 'Erro ao carregar dados para impressão. Tente novamente.' 
      });
    }
  };

  // Funções de gerenciamento do WhatsApp
  const verificarStatusWhatsApp = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`${API_CONFIG.API_URL}/whatsapp/status`, {
        headers: { 'x-auth-token': token }
      });
      
      if (response.data.success) {
        setWhatsappStatus(response.data.status);
        setWhatsappInfo(response.data.info);
        
        // Se o status for 'qr', buscar o QR code
        if (response.data.status === 'qr') {
          buscarQRCode();
        } else {
          setWhatsappQR('');
        }
      }
    } catch (error) {
    }
  };

  const buscarQRCode = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`${API_CONFIG.API_URL}/whatsapp/qr`, {
        headers: { 'x-auth-token': token }
      });
      
      if (response.data.qr) {
        setWhatsappQR(response.data.qr);
      }
    } catch (error) {
    }
  };

  const inicializarWhatsApp = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem('token');
      const response = await axios.post(`${API_CONFIG.API_URL}/whatsapp/initialize`, {}, {
        headers: { 'x-auth-token': token }
      });
      
      if (response.data.success) {
        setMessage({ type: 'success', text: 'Verificando conexão do WhatsApp...' });
        // Atualizar status imediatamente
        verificarStatusWhatsApp();
      }
    } catch (error) {
      setMessage({ 
        type: 'error', 
        text: error.response?.data?.message || 'Erro ao inicializar WhatsApp' 
      });
    } finally {
      setLoading(false);
    }
  };

  const verificarQRCode = async () => {
    const interval = setInterval(async () => {
      try {
        const token = localStorage.getItem('token');
        const response = await axios.get(`${API_CONFIG.API_URL}/whatsapp/qr`, {
          headers: { 'x-auth-token': token }
        });
        
        if (response.data.qr) {
          setWhatsappQR(response.data.qr);
        }
        
        if (response.data.status === 'connected') {
          setWhatsappStatus('connected');
          setWhatsappInfo(response.data.info);
          setWhatsappQR('');
          clearInterval(interval);
          setMessage({ type: 'success', text: 'WhatsApp conectado com sucesso!' });
        }
      } catch (error) {
        clearInterval(interval);
      }
    }, 2000);

    // Limpar interval após 5 minutos
    setTimeout(() => clearInterval(interval), 300000);
  };

  const desconectarWhatsApp = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem('token');
      const response = await axios.post(`${API_CONFIG.API_URL}/whatsapp/disconnect`, {}, {
        headers: { 'x-auth-token': token }
      });
      
      if (response.data.success) {
        setMessage({ type: 'success', text: 'WhatsApp desconectado com sucesso!' });
        // Forçar estado disconnected imediatamente
        setWhatsappStatus('disconnected');
        setWhatsappInfo(null);
        setWhatsappQR('');
        
        // Aguardar 3 segundos antes de verificar novamente para garantir cleanup
        setTimeout(() => {
          verificarStatusWhatsApp();
        }, 3000);
      }
    } catch (error) {
      setMessage({ 
        type: 'error', 
        text: error.response?.data?.message || 'Erro ao desconectar WhatsApp' 
      });
    } finally {
      setLoading(false);
    }
  };

  const limparCacheWhatsApp = async () => {
    if (!window.confirm('Tem certeza que deseja limpar o cache do WhatsApp? Você precisará escanear o QR Code novamente.')) {
      return;
    }

    try {
      setLoading(true);
      const token = localStorage.getItem('token');
      const response = await axios.post(`${API_CONFIG.API_URL}/whatsapp/clear-cache`, {}, {
        headers: { 'x-auth-token': token }
      });
      
      if (response.data.success) {
        setMessage({ type: 'success', text: 'Cache do WhatsApp limpo com sucesso!' });
        setWhatsappStatus('disconnected');
        setWhatsappInfo(null);
        setWhatsappQR('');
      }
    } catch (error) {
      setMessage({ 
        type: 'error', 
        text: error.response?.data?.message || 'Erro ao limpar cache do WhatsApp' 
      });
    } finally {
      setLoading(false);
    }
  };

  // ============= FUNÇÕES DE GERENCIAMENTO DE BANCOS =============
  
  const carregarBancos = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`${API_CONFIG.API_URL}/bancos`, {
        headers: { 'x-auth-token': token }
      });
      
      if (response.data.success) {
        setBancos(response.data.data);
      }
    } catch (error) {
      setMessage({ 
        type: 'error', 
        text: 'Erro ao carregar bancos' 
      });
    }
  };

  const padronizarBancos = async () => {
    if (!window.confirm('Isso irá atualizar as chaves dos bancos existentes para o formato padrão. Deseja continuar?')) return;
    
    try {
      setLoading(true);
      const token = localStorage.getItem('token');
      const response = await axios.post(`${API_CONFIG.API_URL}/bancos/padronizar`, {}, {
        headers: { 'x-auth-token': token }
      });

      if (response.data.success) {
        setMessage({ type: 'success', text: response.data.message });
        carregarBancos();
      }
    } catch (error) {
      console.error('Erro ao padronizar bancos:', error);
      setMessage({ type: 'error', text: 'Erro ao padronizar bancos' });
    } finally {
      setLoading(false);
    }
  };

  const abrirModalBanco = (banco = null) => {
    if (banco) {
      const acessos = banco.acessos?.length
        ? banco.acessos
        : (banco.login || banco.senha ? [{ nome: 'Principal', login: banco.login || '', senha: banco.senha || '', principal: true }] : []);
      setBancoEditando(banco);
      setFormBanco({
        nome: banco.nome || '',
        codigo_banco: banco.codigo_banco || '',
        acessos,
        _id: banco._id
      });
    } else {
      setBancoEditando(null);
      setFormBanco({
        nome: '',
        codigo_banco: '',
        acessos: [],
        _id: ''
      });
    }
    setMostrarSenhaBanco(false);
    setShowModalBanco(true);
  };

  const fecharModalBanco = () => {
    setShowModalBanco(false);
    setBancoEditando(null);
    setMostrarSenhaBanco(false);
    setFormBanco({
      nome: '',
      codigo_banco: '',
      acessos: [],
      _id: ''
    });
  };

  const adicionarAcessoBanco = () => setFormBanco(atual => ({
    ...atual,
    acessos: [...(atual.acessos || []), { nome: `Login ${(atual.acessos?.length || 0) + 1}`, login: '', senha: '', principal: !(atual.acessos?.length) }]
  }));

  const atualizarAcessoBanco = (indice, campo, valor) => setFormBanco(atual => ({
    ...atual,
    acessos: atual.acessos.map((acesso, i) => i === indice ? { ...acesso, [campo]: valor } : acesso)
  }));

  const selecionarAcessoPrincipal = indice => setFormBanco(atual => ({
    ...atual,
    acessos: atual.acessos.map((acesso, i) => ({ ...acesso, principal: i === indice }))
  }));

  const removerAcessoBanco = indice => setFormBanco(atual => {
    const removidoEraPrincipal = atual.acessos[indice]?.principal;
    const acessos = atual.acessos.filter((_, i) => i !== indice);
    if (acessos.length && (removidoEraPrincipal || !acessos.some(acesso => acesso.principal))) acessos[0] = { ...acessos[0], principal: true };
    return { ...atual, acessos };
  });

  const salvarBanco = async (e) => {
    e.preventDefault();
    
    if (!formBanco.nome.trim()) {
      setMessage({ type: 'error', text: 'Nome do banco é obrigatório' });
      return;
    }

    if (user?.tipo === 'super_admin' && !lojaContexto) {
      setMessage({
        type: 'error',
        text: 'Para cadastrar um banco como Super Admin, selecione uma loja em Gerenciar Lojas antes.'
      });
      return;
    }

    try {
      setLoading(true);
      const token = localStorage.getItem('token');
      
      if (bancoEditando) {
        // Atualizar banco existente
        const response = await axios.put(
          `${API_CONFIG.API_URL}/bancos/${bancoEditando._id}`,
          formBanco,
          { headers: { 'x-auth-token': token } }
        );
        
        if (response.data.success) {
          setMessage({ type: 'success', text: 'Banco atualizado com sucesso!' });
          carregarBancos();
          fecharModalBanco();
        }
      } else {
        // Criar novo banco
        const response = await axios.post(
          `${API_CONFIG.API_URL}/bancos`,
          formBanco,
          { headers: { 'x-auth-token': token } }
        );
        
        if (response.data.success) {
          setMessage({ type: 'success', text: 'Banco cadastrado com sucesso!' });
          carregarBancos();
          fecharModalBanco();
        }
      }
    } catch (error) {
      setMessage({ 
        type: 'error', 
        text: error.response?.data?.erro || 'Erro ao salvar banco' 
      });
    } finally {
      setLoading(false);
    }
  };

  const toggleAtivoBanco = async (banco) => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.put(
        `${API_CONFIG.API_URL}/bancos/${banco._id}`,
        { ...banco, ativo: !banco.ativo },
        { headers: { 'x-auth-token': token } }
      );
      
      if (response.data.success) {
        setMessage({ 
          type: 'success', 
          text: `Banco ${!banco.ativo ? 'ativado' : 'desativado'} com sucesso!` 
        });
        carregarBancos();
      }
    } catch (error) {
      setMessage({ 
        type: 'error', 
        text: 'Erro ao alterar status do banco' 
      });
    }
  };

  const excluirBanco = async (bancoId) => {
    if (!window.confirm('Tem certeza que deseja excluir este banco?')) {
      return;
    }

    try {
      setLoading(true);
      const token = localStorage.getItem('token');
      const response = await axios.delete(
        `${API_CONFIG.API_URL}/bancos/${bancoId}`,
        { headers: { 'x-auth-token': token } }
      );
      
      if (response.data.success) {
        setMessage({ type: 'success', text: 'Banco excluído com sucesso!' });
        carregarBancos();
      }
    } catch (error) {
      setMessage({ 
        type: 'error', 
        text: error.response?.data?.erro || 'Erro ao excluir banco' 
      });
    } finally {
      setLoading(false);
    }
  };

  // Verificar status do WhatsApp ao abrir configurações
  useEffect(() => {
    if (activeMenu === 'configuracoes') {
      if (configSubmenu === 'whatsapp') {
        verificarStatusWhatsApp();
        
        // Polling automático para atualizar status
        const interval = setInterval(() => {
          verificarStatusWhatsApp();
        }, 5000); // A cada 5 segundos
        
        return () => clearInterval(interval);
      } else if (configSubmenu === 'fornecedores') {
        carregarFornecedores();
      } else if (configSubmenu === 'bancos') {
        carregarBancos();
      } else if (configSubmenu === 'estoque') {
        carregarStatusSync();
      }
    }
  }, [activeMenu, configSubmenu, lojaContexto]);

  // Carregar veículos quando a seção de estoque for ativa ou no dashboard inicial
  useEffect(() => {
    if (activeMenu === 'estoque' || activeMenu === 'inicio') {
      carregarVeiculos();
    }
  }, [activeMenu, searchVeiculos, statusVeiculoFilter, tipoVeiculoFilter, lojaContexto]);

  // Função para ordenar veículos
  const handleOrdenar = (coluna) => {
    if (ordenarPor === coluna) {
      // Se clicar na mesma coluna, inverte a ordem
      setOrdem(ordem === 'asc' ? 'desc' : 'asc');
    } else {
      // Se clicar em coluna diferente, ordena ascendente
      setOrdenarPor(coluna);
      setOrdem('asc');
    }
  };

  // Ordenar e filtrar veículos
  const veiculosOrdenados = [...veiculos]
    .filter(veiculo => {
      // Filtro por status
      if (statusVeiculoFilter !== 'Todos' && veiculo.status !== statusVeiculoFilter) {
        return false;
      }
      // Filtro por tipo (repasse)
      if (tipoVeiculoFilter !== 'Todos') {
        if (tipoVeiculoFilter === 'Repasse' && !veiculo.tipo?.includes('Repasse')) {
          return false;
        }
        if (tipoVeiculoFilter === 'Venda normal' && veiculo.tipo !== 'Venda normal') {
          return false;
        }
      }
      // Filtro por busca - busca flexível em qualquer parte do texto
      if (searchTerm) {
        const search = searchTerm.toLowerCase().trim();
        const termosBusca = search.split(/\s+/).filter(t => t.length > 0);

        // Combinar todos os campos de busca em um único texto
        const textoCompleto = [
          veiculo.marca || '',
          veiculo.modelo || '',
          veiculo.placa || '',
          veiculo.cor || '',
          veiculo.combustivel || '',
          veiculo.cambio || ''
        ].join(' ').toLowerCase();

        // Verificar se TODOS os termos de busca estão presentes no texto completo
        const todosTermosEncontrados = termosBusca.every(termo =>
          textoCompleto.includes(termo)
        );

        if (!todosTermosEncontrados) {
          return false;
        }
      }
      return true;
    })
    .sort((a, b) => {
    let valorA, valorB;

    switch (ordenarPor) {
      case 'veiculo':
        valorA = `${a.marca} ${a.modelo}`.toLowerCase();
        valorB = `${b.marca} ${b.modelo}`.toLowerCase();
        break;
      case 'ano':
        valorA = a.ano_modelo || 0;
        valorB = b.ano_modelo || 0;
        break;
      case 'cor':
        valorA = (a.cor || '').toLowerCase();
        valorB = (b.cor || '').toLowerCase();
        break;
      case 'placa':
        valorA = a.placa || '';
        valorB = b.placa || '';
        break;
      case 'km':
        valorA = a.km || 0;
        valorB = b.km || 0;
        break;
      case 'preco':
        valorA = a.preco_venda || a.preco || 0;
        valorB = b.preco_venda || b.preco || 0;
        break;
      case 'fipe':
        valorA = a.fipe_valor || 0;
        valorB = b.fipe_valor || 0;
        break;
      case 'localizacao':
        valorA = a.localizacao || '';
        valorB = b.localizacao || '';
        break;
      default:
        return 0;
    }

    if (valorA < valorB) return ordem === 'asc' ? -1 : 1;
    if (valorA > valorB) return ordem === 'asc' ? 1 : -1;
    return 0;
  });

  const fecharModalIA = () => setIaModal(iaEstadoInicial);

  const toggleSelecionarVeiculo = (veiculoId) => {
    if (!veiculoId) return;
    setVeiculosSelecionados((prev) =>
      prev.includes(veiculoId)
        ? prev.filter((id) => id !== veiculoId)
        : [...prev, veiculoId]
    );
  };

  const gerarListaVeiculosSelecionados = async () => {
    const selecionados = veiculos.filter((v) => v && veiculosSelecionados.includes(v._id));
    if (selecionados.length === 0) return;

    const ordenados = [...selecionados].sort((a, b) => {
      const precoA = (() => {
        const bruto = a.preco_venda ?? a.preco ?? 0;
        if (typeof bruto === 'number') return bruto;
        const limpo = String(bruto).replace(/[^\d.,-]/g, '').replace(/\.(?=\d{3})/g, '').replace(',', '.');
        const parsed = parseFloat(limpo);
        return Number.isNaN(parsed) ? 0 : parsed;
      })();

      const precoB = (() => {
        const bruto = b.preco_venda ?? b.preco ?? 0;
        if (typeof bruto === 'number') return bruto;
        const limpo = String(bruto).replace(/[^\d.,-]/g, '').replace(/\.(?=\d{3})/g, '').replace(',', '.');
        const parsed = parseFloat(limpo);
        return Number.isNaN(parsed) ? 0 : parsed;
      })();

      return precoB - precoA; // ordem decrescente (mais caro primeiro)
    });

    const linhas = ordenados.map((v) => {
      const nomeBase = [v.marca, v.modelo].filter(Boolean).join(' ').trim();
      const versao = v.versao && !nomeBase.toLowerCase().includes(String(v.versao).toLowerCase()) ? ` ${v.versao}` : '';
      const nomeVeiculo = `${nomeBase}${versao}`.trim();
      const ano = v.anoModelo
        || v.ano_modelo
        || v.anoVeiculo
        || v.ano
        || v.anoFabricacao
        || '';
      const nomeComAno = ano ? `${nomeVeiculo} (${ano})` : nomeVeiculo;
      const precoBruto = v.preco_venda ?? v.preco ?? 0;
      const precoNumero = (() => {
        if (typeof precoBruto === 'number') return precoBruto;
        const limpo = String(precoBruto).replace(/[^\d.,-]/g, '').replace(/\.(?=\d{3})/g, '').replace(',', '.');
        const parsed = parseFloat(limpo);
        return Number.isNaN(parsed) ? 0 : parsed;
      })();
      const precoFormatado = `R$ ${precoNumero.toLocaleString('pt-BR', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`;
      return `- *${nomeComAno}* - ${precoFormatado}`;
    }).join('\n\n');

    try {
      await navigator.clipboard.writeText(linhas);
      setMessage({ type: 'success', text: 'Lista copiada para a área de transferência' });
      setVeiculosSelecionados([]); // limpar seleção após copiar para evitar contagem acumulada
    } catch (error) {
      setMessage({ type: 'error', text: 'Não foi possível copiar a lista' });
    }
  };

  const abrirFerramentasIA = (veiculo) => {
    if (!veiculo || !veiculo._id) return;

    setIaModal({
      ...iaEstadoInicial,
      aberto: true,
      veiculo,
      titulo: 'Ferramentas IA'
    });

    buscarApresentacaoSalva(veiculo);
  };

  const buscarApresentacaoSalva = async (veiculo) => {
    if (!veiculo || !veiculo._id) return;

    setIaModal((prev) => ({
      ...prev,
      loading: true,
      erro: false,
      conteudo: 'Buscando apresentação salva...'
    }));

    try {
      const token = localStorage.getItem('token');
      const response = await axios.post(
        `${API_CONFIG.API_URL}/veiculos/${veiculo._id}/apresentacao`,
        {},
        { headers: { 'x-auth-token': token } }
      );

      const texto = response.data?.apresentacao;
      setIaModal((prev) => ({
        ...prev,
        tipo: 'apresentacao',
        titulo: 'Ferramentas IA',
        conteudo: texto || 'Nenhuma apresentação salva. Clique em Gerar para criar.',
        loading: false,
        erro: false
      }));
    } catch (error) {
      setIaModal((prev) => ({
        ...prev,
        loading: false,
        erro: false,
        conteudo: 'Nenhuma apresentação salva. Clique em Gerar para criar.'
      }));
    }
  };

  const gerarConteudoIA = async () => {
    if (!iaModal.veiculo || !iaModal.veiculo._id) return;

    if (iaModal.tipo === 'confronto' && !iaModal.modeloComparacao.trim()) {
      setIaModal((prev) => ({
        ...prev,
        erro: true,
        conteudo: 'Informe o modelo/ano para confronto.',
        titulo: 'Ferramentas IA'
      }));
      return;
    }

    setIaModal((prev) => ({
      ...prev,
      loading: true,
      erro: false,
      conteudo: 'Gerando resposta da IA...'
    }));

    try {
      const token = localStorage.getItem('token');
      const endpoint = iaModal.tipo === 'apresentacao'
        ? `${API_CONFIG.API_URL}/veiculos/${iaModal.veiculo._id}/apresentacao`
        : `${API_CONFIG.API_URL}/veiculos/${iaModal.veiculo._id}/confronto`;
      const payload = iaModal.tipo === 'apresentacao'
        ? {}
        : { modeloComparacao: iaModal.modeloComparacao.trim() };

      const response = await axios.post(endpoint, payload, { headers: { 'x-auth-token': token } });
      const texto = iaModal.tipo === 'apresentacao'
        ? response.data?.apresentacao
        : response.data?.confronto;

      setIaModal((prev) => ({
        ...prev,
        titulo: 'Ferramentas IA',
        conteudo: texto || 'Nenhum texto retornado pela IA.',
        loading: false,
        erro: false
      }));
    } catch (error) {
      setIaModal((prev) => ({
        ...prev,
        titulo: 'Erro ao gerar IA',
        conteudo: error.response?.data?.message || error.message || 'Erro desconhecido',
        loading: false,
        erro: true
      }));
    }
  };

  const copiarConteudoIA = async () => {
    if (!iaModal.conteudo) return;

    try {
      await navigator.clipboard.writeText(iaModal.conteudo);
      setMessage({ type: 'success', text: 'Copiado para a área de transferência' });
    } catch (error) {
      setMessage({ type: 'error', text: 'Não foi possível copiar o texto' });
    }
  };

  // Carregar usuários
  const carregarUsuarios = async () => {
    setLoadingUsuarios(true);
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`${API_CONFIG.API_URL}/usuarios`, {
        headers: {
          'Authorization': `Bearer ${token}`
        },
        params: {
          search: searchUsuarios
        }
      });
      
      if (response.data.success) {
        
        // Ordenar usuários: Gerentes > Analistas > Vendedores (alfabético dentro de cada grupo)
        const usuariosOrdenados = Array.isArray(response.data.data) ? [...response.data.data].sort((a, b) => {
          const ordemCargo = { 'Gerente': 1, 'Analista': 2, 'Financeiro': 3, 'Vendedor': 4 };
          const cargoA = ordemCargo[a.cargo] || 999;
          const cargoB = ordemCargo[b.cargo] || 999;
          
          if (cargoA !== cargoB) {
            return cargoA - cargoB;
          }
          
          // Mesma prioridade de cargo: ordenar alfabeticamente por nome
          return (a.nome || '').localeCompare(b.nome || '', 'pt-BR');
        }) : [];
        
        setUsuarios(usuariosOrdenados);
      } else {
        setUsuarios([]);
      }
    } catch (error) {
      setUsuarios([]);
      if (error.response && error.response.status === 401) {
        onLogout();
      }
    } finally {
      setLoadingUsuarios(false);
    }
  };

  // Carregar usuários quando a seção de usuários for ativa
  useEffect(() => {
    if (activeMenu === 'usuarios' || (activeMenu === 'configuracoes' && configSubmenu === 'usuarios')) {
      carregarUsuarios();
    }
  }, [activeMenu, configSubmenu, searchUsuarios]);

  // Buscar usuário completo por ID antes de editar
  const buscarUsuarioCompleto = async (usuarioId) => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`${API_CONFIG.API_URL}/usuarios/${usuarioId}`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      
      if (response.data.success) {
        setUsuarioParaEditar(response.data.data);
      }
    } catch (error) {
    }
  };

  // Verificar permissões do usuário para veículos
  const podeEditarVeiculo = () => {
    return user.cargo === 'Gerente' || user.cargo === 'Analista' || user.tipo === 'super_admin';
  };

  const podeExcluirVeiculo = () => {
    return user.cargo === 'Gerente' || user.tipo === 'super_admin';
  };

  const podeCadastrarVeiculo = () => {
    return user.cargo === 'Gerente' || user.cargo === 'Analista' || user.tipo === 'super_admin';
  };

  // Função para definir classe CSS do cargo
  const getCargoClass = (cargo) => {
    switch (cargo) {
      case 'Gerente':
        return 'cargo-gerente';
      case 'Analista':
        return 'cargo-analista';
      case 'Vendedor':
        return 'cargo-vendedor';
      case 'Financeiro':
        return 'cargo-financeiro';
      default:
        return '';
    }
  };

  // Criar nova ficha
  const criarNovaFicha = async (fichaData) => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.post(`${API_CONFIG.API_URL}/fichas`, fichaData, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      
      if (response.data.success) {
        // Recarregar fichas e estatísticas
        if (activeMenu === 'fichas') {
          carregarFichas();
        }
        carregarEstatisticas();
        setMessage({ type: 'success', text: 'Ficha criada com sucesso!' });
      }
    } catch (error) {
      if (error.response && error.response.status === 401) {
        onLogout();
      } else {
        setMessage({ type: 'error', text: error.response?.data?.message || 'Erro ao criar ficha. Tente novamente.' });
      }
    }
  };

  // Funções de paginação
  const paginar = (items, paginaAtual, itensPorPag = itensPorPagina) => {
    const indiceInicio = (paginaAtual - 1) * itensPorPag;
    const indiceFim = indiceInicio + itensPorPag;
    return items.slice(indiceInicio, indiceFim);
  };

  const totalPaginas = (items, itensPorPag = itensPorPagina) => {
    return Math.ceil(items.length / itensPorPag);
  };

  const Paginacao = ({ paginaAtual, totalPags, onPaginaChange }) => {
    if (totalPags <= 1) return null;

    const paginas = [];
    const maxPaginasVisiveis = 5;
    let inicio = Math.max(1, paginaAtual - Math.floor(maxPaginasVisiveis / 2));
    let fim = Math.min(totalPags, inicio + maxPaginasVisiveis - 1);

    if (fim - inicio + 1 < maxPaginasVisiveis) {
      inicio = Math.max(1, fim - maxPaginasVisiveis + 1);
    }

    for (let i = inicio; i <= fim; i++) {
      paginas.push(i);
    }

    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '8px',
        marginTop: '20px',
        paddingBottom: '20px'
      }}>
        <button
          onClick={() => onPaginaChange(paginaAtual - 1)}
          disabled={paginaAtual === 1}
          style={{
            padding: '8px 12px',
            border: '1px solid #ddd',
            background: paginaAtual === 1 ? '#f5f5f5' : 'white',
            cursor: paginaAtual === 1 ? 'not-allowed' : 'pointer',
            borderRadius: '4px',
            color: paginaAtual === 1 ? '#999' : '#333'
          }}
        >
          Anterior
        </button>

        {inicio > 1 && (
          <>
            <button
              onClick={() => onPaginaChange(1)}
              style={{
                padding: '8px 12px',
                border: '1px solid #ddd',
                background: 'white',
                cursor: 'pointer',
                borderRadius: '4px'
              }}
            >
              1
            </button>
            {inicio > 2 && <span style={{ padding: '0 8px' }}>...</span>}
          </>
        )}

        {paginas.map(pagina => (
          <button
            key={pagina}
            onClick={() => onPaginaChange(pagina)}
            style={{
              padding: '8px 12px',
              border: '1px solid #ddd',
              background: pagina === paginaAtual ? '#3498db' : 'white',
              color: pagina === paginaAtual ? 'white' : '#333',
              cursor: 'pointer',
              borderRadius: '4px',
              fontWeight: pagina === paginaAtual ? 'bold' : 'normal'
            }}
          >
            {pagina}
          </button>
        ))}

        {fim < totalPags && (
          <>
            {fim < totalPags - 1 && <span style={{ padding: '0 8px' }}>...</span>}
            <button
              onClick={() => onPaginaChange(totalPags)}
              style={{
                padding: '8px 12px',
                border: '1px solid #ddd',
                background: 'white',
                cursor: 'pointer',
                borderRadius: '4px'
              }}
            >
              {totalPags}
            </button>
          </>
        )}

        <button
          onClick={() => onPaginaChange(paginaAtual + 1)}
          disabled={paginaAtual === totalPags}
          style={{
            padding: '8px 12px',
            border: '1px solid #ddd',
            background: paginaAtual === totalPags ? '#f5f5f5' : 'white',
            cursor: paginaAtual === totalPags ? 'not-allowed' : 'pointer',
            borderRadius: '4px',
            color: paginaAtual === totalPags ? '#999' : '#333'
          }}
        >
          Próximo
        </button>
      </div>
    );
  };

  // Função para definir classe CSS do status
  const getStatusClass = (status) => {
    if (!status) return 'initiated';
    switch (status) {
      case 'Aprovada':
      case 'Com possibilidade':
        return 'approved';
      case 'Enviada para análise':
        return 'pending';
      case 'Recusada':
        return 'rejected';
      case 'Cancelada':
        return 'cancelled';
      default:
        return 'initiated';
    }
  };

  // Função para converter nome para Camel Case (Primeira Letra Maiúscula)
  const formatarNomeCamelCase = (nome) => {
    if (!nome) return nome;
    return nome
      .toLowerCase()
      .split(' ')
      .map(palavra => palavra.charAt(0).toUpperCase() + palavra.slice(1))
      .join(' ');
  };

  const renderContent = () => {
    // O analista mantém a gestão de acessos mesmo sem outros menus autorizados.
    // Isso não concede acesso às demais configurações nem às rotas de usuários.
    if (user?.gerenciar_acessos && activeMenu === 'configuracoes' && !user.menus_efetivos?.includes('configuracoes')) {
      return <section className="content-section"><h1>Configurações · Usuários</h1><AcessosUsuarios embedded onAtualizar={atualizarAcessos} /></section>;
    }
    if (user?.tipo !== 'super_admin') {
      const menu = ({ inicio: 'fichas', simulacoes: 'fichas', usuarios: 'configuracoes' })[activeMenu] || activeMenu;
      const autorizado = activeMenu === 'acessos' ? user?.gerenciar_acessos : user?.menus_efetivos?.includes(menu);
      if (!autorizado) return <div style={{ padding: 24 }}>Nenhum acesso disponível nesta tela. Consulte o analista da loja.</div>;
    }
    switch (activeMenu) {
      case 'financeiro_contas':
        return (
          <ContasPagar user={user} lojaContexto={lojaContexto} onToggleSidebar={() => setSidebarOpen(!sidebarOpen)} onAbrirNegociacao={user?.tipo === 'super_admin' || user?.menus_efetivos?.includes('negociacoes') ? id => { setNegociacaoOrigemId(String(id)); setActiveMenu('negociacoes'); } : undefined} />
        );

      case 'documentacao':
        return (
          <DocumentacaoKanban user={user} onToggleSidebar={() => setSidebarOpen(!sidebarOpen)} />
        );

      case 'bps_acessos':
        if (user?.tipo !== 'super_admin' || lojaContexto) return <div>Página não encontrada</div>;
        return (
          <div className="content-section">
            <div className="page-header-mobile">
              <button
                className="mobile-menu-toggle"
                onClick={() => setSidebarOpen(!sidebarOpen)}
              >
                ☰
              </button>
              <h1>Acessos BPS</h1>
            </div>
            <div style={{ background: '#fff', border: '1px solid #e2e8f0', borderRadius: '12px', padding: '24px', marginTop: '1.5rem', maxWidth: '760px' }}>
              <h2 style={{ margin: '0 0 8px', color: '#1e293b' }}>Usuários do portal BPS</h2>
              <p style={{ margin: '0 0 20px', color: '#64748b' }}>Cadastre acessos independentes para o painel Premium Beef Sorocaba.</p>
              <button className="btn-primary" style={{ background: '#2563eb' }} onClick={() => setShowBpsModal(true)}>
                Novo acesso BPS
              </button>
            </div>
          </div>
        );

      case 'estoque':
        return (
          <div className="content-section">
            <div className="page-header-mobile">
              <button 
                className="mobile-menu-toggle"
                onClick={() => setSidebarOpen(!sidebarOpen)}
              >
                ☰
              </button>
              <h1>Estoque de Veículos</h1>
            </div>
            <div className="section-actions section-actions-estoque" style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
              <div style={{ flex: 1, display: 'flex', gap: '10px', alignItems: 'center' }}>
                <input 
                  type="search" 
                  placeholder="Buscar veículos por marca, modelo ou placa..." 
                  className="search-input"
                  style={{ flex: 1, maxWidth: 'none' }}
                  value={searchVeiculos}
                  onChange={(e) => setSearchVeiculos(e.target.value)}
                />
              </div>
              <div className="estoque-buttons-group" style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                <button 
                  onClick={() => setShowFiltrosVeiculos(!showFiltrosVeiculos)}
                  className="btn-primary estoque-action-button"
                  style={{
                    padding: '10px 16px',
                    minWidth: 'auto',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px',
                    position: 'relative',
                    fontSize: '1.2rem'
                  }}
                  title="Mostrar/ocultar filtros"
                  aria-label="Mostrar ou ocultar filtros do estoque"
                >
                  ☰
                  <span className="estoque-action-label">Filtros</span>
                  {(statusVeiculoFilter !== 'Todos' || tipoVeiculoFilter !== 'Todos') && (
                    <span style={{
                      background: '#e74c3c',
                      color: 'white',
                      borderRadius: '50%',
                      width: '18px',
                      height: '18px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontSize: '0.65rem',
                      fontWeight: 'bold',
                      position: 'absolute',
                      top: '-5px',
                      right: '-5px',
                      border: '2px solid white'
                    }}>
                      !
                    </span>
                  )}
                </button>
                <button 
                  className="btn-primary estoque-action-button" 
                  onClick={imprimirEstoque}
                  style={{
                    padding: '10px 16px',
                    minWidth: 'auto'
                  }}
                  title="Imprimir Estoque"
                  aria-label="Imprimir estoque"
                >
                  🖨️
                  <span className="estoque-action-label">Imprimir</span>
                </button>
                <button 
                  className="btn-primary estoque-action-button" 
                  onClick={() => {
                    setShowHistoricoRemovidos(true);
                    carregarRemovidos();
                  }}
                  style={{
                    padding: '10px 16px',
                    minWidth: 'auto'
                  }}
                  title="Histórico de Removidos"
                  aria-label="Abrir histórico de removidos"
                >
                  📋
                  <span className="estoque-action-label">Removidos</span>
                </button>
                {podeCadastrarVeiculo() && (
                  <button className="btn-primary btn-cadastrar-veiculo estoque-action-button" onClick={() => setShowCadastrarVeiculo(true)}>
                    Cadastrar
                  </button>
                )}
              </div>
            </div>

            {/* Filtros - Mostrar apenas quando showFiltrosVeiculos for true */}
            {showFiltrosVeiculos && (
              <div className="estoque-filtros-panel" style={{ 
                display: 'flex', 
                gap: '15px', 
                marginTop: '15px',
                marginBottom: '20px',
                padding: '15px',
                background: '#f8f9fa',
                borderRadius: '8px',
                alignItems: 'center',
                border: '2px solid #3498db'
              }}>
                <div className="estoque-filtro-campo" style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
                  <label style={{ fontSize: '0.9rem', fontWeight: '500', color: '#555' }}>Status:</label>
                  <select 
                    value={statusVeiculoFilter}
                    onChange={(e) => setStatusVeiculoFilter(e.target.value)}
                    style={{
                      padding: '8px 12px',
                      borderRadius: '5px',
                      border: '1px solid #ddd',
                      fontSize: '0.95rem',
                      minWidth: '150px',
                      cursor: 'pointer'
                    }}
                  >
                    <option value="Todos">Todos</option>
                    <option value="Disponível">Disponível</option>
                    <option value="Em negociação">Em negociação</option>
                    <option value="Em preparação">Em preparação</option>
                  </select>
                </div>

                <div className="estoque-filtro-campo" style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
                  <label style={{ fontSize: '0.9rem', fontWeight: '500', color: '#555' }}>Tipo:</label>
                  <select 
                    value={tipoVeiculoFilter}
                    onChange={(e) => setTipoVeiculoFilter(e.target.value)}
                    style={{
                      padding: '8px 12px',
                      borderRadius: '5px',
                      border: '1px solid #ddd',
                      fontSize: '0.95rem',
                      minWidth: '150px',
                      cursor: 'pointer'
                    }}
                  >
                    <option value="Todos">Todos</option>
                    <option value="Venda normal">Venda normal</option>
                    <option value="Repasse">Repasses</option>
                  </select>
                </div>

                <button
                  className="estoque-limpar-filtros"
                  onClick={() => {
                    setStatusVeiculoFilter('Todos');
                    setTipoVeiculoFilter('Todos');
                  }}
                  style={{
                    padding: '8px 15px',
                    background: '#e74c3c',
                    color: 'white',
                    border: 'none',
                    borderRadius: '5px',
                    cursor: 'pointer',
                    fontSize: '0.9rem',
                    fontWeight: '500',
                    marginLeft: '10px'
                  }}
                  title="Limpar filtros"
                >
                  Limpar
                </button>

                <div className="estoque-filtros-total" style={{ marginLeft: 'auto', fontSize: '0.9rem', color: '#666' }}>
                  <strong>{veiculosOrdenados.length}</strong> veículo(s) encontrado(s)
                </div>
              </div>
            )}
            <div className="estoque-mobile-summary">
              <span><strong>{veiculosOrdenados.length}</strong> veículo(s)</span>
              <div className="estoque-mobile-sort">
                <label htmlFor="estoque-ordenacao-mobile">Ordenar:</label>
                <select
                  id="estoque-ordenacao-mobile"
                  value={ordenarPor}
                  onChange={(e) => setOrdenarPor(e.target.value)}
                >
                  <option value="veiculo">Veículo</option>
                  <option value="ano">Ano</option>
                  <option value="cor">Cor</option>
                  <option value="placa">Placa</option>
                  <option value="km">KM</option>
                  <option value="preco">Preço</option>
                </select>
                <button
                  type="button"
                  onClick={() => setOrdem(prev => prev === 'asc' ? 'desc' : 'asc')}
                  aria-label={ordem === 'asc' ? 'Alterar para ordem decrescente' : 'Alterar para ordem crescente'}
                  title={ordem === 'asc' ? 'Ordem crescente' : 'Ordem decrescente'}
                >
                  {ordem === 'asc' ? '↑' : '↓'}
                </button>
              </div>
            </div>
            {veiculosSelecionados.length > 0 && (
              <div
                className="estoque-selection-bar"
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  gap: '12px',
                  padding: '10px 12px',
                  marginTop: '10px',
                  marginBottom: '10px',
                  background: '#f8fafc',
                  border: '1px solid #e5e7eb',
                  borderRadius: '8px'
                }}
              >
                <span style={{ color: '#374151', fontWeight: 600 }}>
                  Selecionados: <strong>{veiculosSelecionados.length}</strong>
                </span>
                <button
                  type="button"
                  onClick={gerarListaVeiculosSelecionados}
                  style={{
                    padding: '10px 14px',
                    background: '#27ae60',
                    color: '#ffffff',
                    border: 'none',
                    borderRadius: '8px',
                    fontWeight: 700,
                    cursor: 'pointer',
                    boxShadow: '0 8px 18px rgba(39,174,96,0.18)'
                  }}
                  title="Copiar lista dos veículos selecionados"
                >
                  Copiar seleção
                </button>
              </div>
            )}
            
            {loadingVeiculos ? (
              <div className="loading">Carregando veículos...</div>
            ) : (
              <div className="table-container estoque-lista-mobile">
                <table className="data-table veiculos-table">
                  <thead>
                    <tr>
                      <th 
                        onClick={() => handleOrdenar('veiculo')}
                        style={{ cursor: 'pointer', userSelect: 'none', minWidth: '150px', flex: '1' }}
                      >
                        Veículo {ordenarPor === 'veiculo' && (ordem === 'asc' ? '↑' : '↓')}
                      </th>
                      <th 
                        onClick={() => handleOrdenar('ano')}
                        style={{width: '55px', textAlign: 'center', cursor: 'pointer', userSelect: 'none'}}
                      >
                        Ano {ordenarPor === 'ano' && (ordem === 'asc' ? '↑' : '↓')}
                      </th>
                      <th 
                        onClick={() => handleOrdenar('cor')}
                        style={{width: '75px', textAlign: 'center', cursor: 'pointer', userSelect: 'none'}}
                      >
                        Cor {ordenarPor === 'cor' && (ordem === 'asc' ? '↑' : '↓')}
                      </th>
                      <th 
                        onClick={() => handleOrdenar('placa')}
                        style={{width: '80px', textAlign: 'center', cursor: 'pointer', userSelect: 'none'}}
                      >
                        Placa {ordenarPor === 'placa' && (ordem === 'asc' ? '↑' : '↓')}
                      </th>
                      <th 
                        onClick={() => handleOrdenar('km')}
                        style={{width: '85px', textAlign: 'right', cursor: 'pointer', userSelect: 'none'}}
                      >
                        KM {ordenarPor === 'km' && (ordem === 'asc' ? '↑' : '↓')}
                      </th>
                      <th 
                        onClick={() => handleOrdenar('preco')}
                        style={{width: '95px', textAlign: 'right', cursor: 'pointer', userSelect: 'none'}}
                      >
                        Preço {ordenarPor === 'preco' && (ordem === 'asc' ? '↑' : '↓')}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {!veiculosOrdenados || veiculosOrdenados.length === 0 ? (
                      <tr>
                        <td colSpan="6" style={{textAlign: 'center', padding: '2rem'}}>
                          Nenhum veículo cadastrado
                        </td>
                      </tr>
                    ) : (
                      veiculosOrdenados.map((veiculo) => (
                        <tr 
                          key={veiculo._id}
                          onMouseEnter={() => setVeiculoHoverId(veiculo._id)}
                          onMouseLeave={() => setVeiculoHoverId(null)}
                        >
                          <td 
                            className="veiculo-card-principal"
                            style={{minWidth: '150px', flex: '1', maxWidth: '250px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'}}
                            title={`${veiculo.marca} ${veiculo.modelo}`}
                          >
                            <div className="veiculo-card-main-row" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                              <button
                                className="veiculo-ia-button"
                                type="button"
                                onClick={() => abrirFerramentasIA(veiculo)}
                                title="Ferramentas IA"
                                style={{
                                  background: 'linear-gradient(135deg, #5b6ef5 0%, #3498db 100%)',
                                  color: 'white',
                                  border: 'none',
                                  borderRadius: '8px',
                                  padding: '5px 10px',
                                  fontWeight: 700,
                                  fontSize: '12px',
                                  letterSpacing: '0.2px',
                                  boxShadow: '0 4px 12px rgba(91,110,245,0.28)',
                                  cursor: 'pointer',
                                  transition: 'transform 0.12s ease, box-shadow 0.2s ease'
                                }}
                                onMouseEnter={(e) => {
                                  e.currentTarget.style.transform = 'translateY(-1px)';
                                  e.currentTarget.style.boxShadow = '0 6px 16px rgba(91,110,245,0.35)';
                                }}
                                onMouseLeave={(e) => {
                                  e.currentTarget.style.transform = 'none';
                                  e.currentTarget.style.boxShadow = '0 4px 12px rgba(91,110,245,0.28)';
                                }}
                              >
                                IA
                              </button>
                              <input
                                className="veiculo-select-checkbox"
                                type="checkbox"
                                checked={veiculosSelecionados.includes(veiculo._id)}
                                onChange={() => toggleSelecionarVeiculo(veiculo._id)}
                                style={{ width: '18px', height: '18px', cursor: 'pointer' }}
                                aria-label="Selecionar veículo para lista"
                              />
                              <span 
                                className="veiculo-nome-link"
                                onClick={() => {
                                  setVeiculoParaEditar(veiculo);
                                  setShowCadastrarVeiculo(true);
                                }}
                                style={{
                                  cursor: 'pointer',
                                  color: '#3498db',
                                  textDecoration: 'underline',
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: '6px'
                                }}
                              >
                                {veiculo.marca} {veiculo.modelo}
                                {/* Mostrar ícone apenas para veículos acompanhados */}
                                {(() => {
                                  if (!user || !user.id || !veiculo.seguidores) return null;
                                  
                                  const userIdStr = String(user.id);
                                  const estaSeguindo = veiculo.seguidores.some(seg => {
                                    if (!seg) return false;
                                    return String(seg) === userIdStr;
                                  });
                                  
                                  return estaSeguindo ? (
                                    <span
                                      className="veiculo-seguindo-indicador"
                                      style={{
                                        fontSize: '0.85rem',
                                        display: 'flex',
                                        alignItems: 'center',
                                        color: '#3498db'
                                      }}
                                      title="Você está acompanhando este veículo"
                                    >
                                      🔔
                                    </span>
                                  ) : null;
                                })()}
                              </span>
                              {veiculo.tipo && veiculo.tipo.includes('Repasse') && (
                                <span className="veiculo-tipo-badge" style={{
                                  background: '#ff9800',
                                  color: 'white',
                                  padding: '2px 8px',
                                  borderRadius: '12px',
                                  fontSize: '0.75rem',
                                  fontWeight: '600',
                                  whiteSpace: 'nowrap'
                                }}>
                                  {veiculo.tipo}
                                </span>
                              )}
                            </div>
                          </td>
                          <td data-label="Ano" style={{textAlign: 'center'}} title={
                            veiculo.ano_fabricacao && veiculo.ano_modelo 
                              ? `Ano Fabricação: ${veiculo.ano_fabricacao} / Modelo: ${veiculo.ano_modelo}`
                              : veiculo.ano_modelo 
                                ? `Ano Modelo: ${veiculo.ano_modelo}`
                                : veiculo.ano 
                                  ? `Ano: ${veiculo.ano}`
                                  : 'Ano não informado'
                          }>
                            {veiculo.ano_fabricacao && veiculo.ano_modelo 
                              ? `${String(veiculo.ano_fabricacao).slice(-2)}/${String(veiculo.ano_modelo).slice(-2)}`
                              : veiculo.ano_modelo 
                                ? String(veiculo.ano_modelo).slice(-2)
                                : veiculo.ano 
                                  ? String(veiculo.ano).slice(-2)
                                  : '-'
                            }
                          </td>
                          <td data-label="Cor" style={{textAlign: 'center'}} title={veiculo.cor || 'Cor não informada'}>
                            {veiculo.cor || '-'}
                          </td>
                          <td data-label="Placa" style={{textAlign: 'center'}} title={veiculo.placa || 'Placa não informada'}>{veiculo.placa ? veiculo.placa.replace(/-/g, '') : '-'}</td>
                          <td data-label="KM" style={{textAlign: 'right', paddingRight: '12px'}} title={`Quilometragem: ${veiculo.km ? veiculo.km.toLocaleString('pt-BR') + ' km' : '0 km'}`}>
                            {veiculo.km ? veiculo.km.toLocaleString('pt-BR') : '0'}
                          </td>
                          <td data-label="Preço" style={{textAlign: 'right', paddingRight: '12px'}} title={`Preço: R$ ${veiculo.preco_venda ? veiculo.preco_venda.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : (veiculo.preco ? veiculo.preco.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '0,00')}`}>
                            R$ {veiculo.preco_venda ? veiculo.preco_venda.toLocaleString('pt-BR', { minimumFractionDigits: 0, maximumFractionDigits: 0 }) : (veiculo.preco ? veiculo.preco.toLocaleString('pt-BR', { minimumFractionDigits: 0, maximumFractionDigits: 0 }) : '0')}
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        );
      case 'fichas':
        return (
          <div className="content-section fichas-page">
            <div className="negociacoes-fixed-panel fichas-fixed-panel">
              <div className="page-header-mobile">
                <button
                  className="mobile-menu-toggle"
                  onClick={() => setSidebarOpen(!sidebarOpen)}
                >
                  ☰
                </button>
                <h1>Fichas de Financiamento</h1>
              </div>

              <div className="section-actions negociacoes-toolbar-actions fichas-toolbar-actions">
                <input
                  type="text"
                  placeholder="Pesquisar cliente, vendedor, CPF..."
                  className="negociacoes-busca"
                  value={searchTerm}
                  onChange={handleSearch}
                  style={{ padding: '8px 12px', border: '1px solid #e2e8f0', borderRadius: '6px', fontSize: '0.85rem', color: '#334155', background: '#fff', minWidth: '280px', width: 'auto' }}
                />

                <button
                  type="button"
                  className={`negociacoes-filtros-toggle ${filtrosFichasAbertos ? 'open' : ''}`}
                  onClick={() => setFiltrosFichasAbertos(aberto => !aberto)}
                  aria-expanded={filtrosFichasAbertos}
                  aria-controls="fichas-filtros-mobile"
                >
                  <span className="negociacoes-filtros-toggle-label">
                    Filtros
                    {statusFilter !== 'Todos os Status' && <strong>1</strong>}
                  </span>
                  <span className="negociacoes-filtros-toggle-chevron" aria-hidden="true">⌄</span>
                </button>

                <div
                  id="fichas-filtros-mobile"
                  className={`negociacoes-filtros-opcoes ${filtrosFichasAbertos ? 'open' : ''}`}
                >
                  <select value={statusFilter} onChange={handleStatusFilter}>
                    <option>Todos os Status</option>
                    <option>Com possibilidade</option>
                    <option>Enviada para análise</option>
                    <option>Aprovada</option>
                    <option>Recusada</option>
                    <option>Cancelada</option>
                  </select>
                </div>

                <div className="negociacoes-toolbar-buttons">
                  <button
                    type="button"
                    className="btn-primary negociacoes-nova-button"
                    onClick={() => setShowNovaFicha(true)}
                    style={{ padding: '12px 24px', fontSize: '1rem', fontWeight: '600', display: 'flex', alignItems: 'center', gap: '8px', width: 'auto', justifyContent: 'center' }}
                  >
                    Nova Ficha
                  </button>
                </div>
              </div>
            </div>

            <ListaFichas
              fichas={fichas}
              carregando={loading}
              onPreencherFicha={(ficha) => setFichaParaPreencher(ficha)}
              onNovaSimulacao={(ficha) => setFichaParaSimulacao(ficha)}
              searchTerm={searchTerm}
              statusFilter={statusFilter}
              highlightClienteNaLoja={false}
              exibirVendedor={Boolean(user?.permissoes?.fichas?.visualizar_todas)}
            />
          </div>
        );
      case 'simulacoes':
        return (
          <div className="content-section">
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '2rem' }}>
              <h1 style={{ margin: 0 }}>Simulações de Financiamento</h1>
              <button
                onClick={carregarSimulacoes}
                style={{
                  padding: '10px 20px',
                  background: '#3498db',
                  color: 'white',
                  border: 'none',
                  borderRadius: '6px',
                  cursor: 'pointer',
                  fontSize: '0.95rem',
                  fontWeight: '600',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '0.5rem',
                  transition: 'background 0.2s'
                }}
                onMouseEnter={(e) => e.target.style.background = '#2980b9'}
                onMouseLeave={(e) => e.target.style.background = '#3498db'}
              >
                 Atualizar
              </button>
            </div>
            
            {loading ? (
              <div className="loading">Carregando simulações...</div>
            ) : (
              <div className="table-container">
                <table className="data-table">
                  <thead>
                    <tr>
                      <th style={{ width: '100px', textAlign: 'center' }}>Prioridade</th>
                      <th style={{ minWidth: '200px' }}>Cliente</th>
                      <th style={{ width: '150px' }}>Vendedor</th>
                      <th style={{ width: '180px' }}>Veículo</th>
                      <th style={{ width: '120px', textAlign: 'center' }}>Status</th>
                      <th style={{ width: '140px' }}>Data / Hora</th>
                      <th style={{ width: '100px', textAlign: 'center' }}>Ações</th>
                    </tr>
                  </thead>
                  <tbody>
                    {!simulacoes || simulacoes.length === 0 ? (
                      <tr>
                        <td colSpan="6" style={{textAlign: 'center', padding: '2rem'}}>
                          Nenhuma simulação encontrada
                        </td>
                      </tr>
                    ) : (
                      paginar(simulacoes, paginaSimulacoes).map((simulacao) => (
                        <tr 
                          key={simulacao._id}
                        >
                          <td style={{ textAlign: 'center', fontWeight: '600', fontSize: '0.95rem' }}>
                            {simulacao.clienteNaLoja ? (
                              <span style={{ color: '#27ae60' }}>Sim</span>
                            ) : (
                              <span style={{ color: '#95a5a6' }}>Não</span>
                            )}
                          </td>
                          <td style={{ fontWeight: '500' }}>
                            {simulacao.nome || simulacao.cliente?.nome || 'Não informado'}
                          </td>
                          <td 
                            style={{ 
                              whiteSpace: 'nowrap', 
                              overflow: 'hidden', 
                              textOverflow: 'ellipsis',
                              maxWidth: '150px'
                            }}
                            title={simulacao.usuario_id?.nome || 'Não informado'}
                          >
                            {simulacao.usuario_id?.nome || 'Não informado'}
                          </td>
                          <td 
                            style={{ 
                              whiteSpace: 'nowrap', 
                              overflow: 'hidden', 
                              textOverflow: 'ellipsis',
                              maxWidth: '180px'
                            }}
                            title={simulacao.veiculo || 'Não informado'}
                          >
                            {simulacao.veiculo || 'Não informado'}
                          </td>
                          <td style={{ textAlign: 'center' }}>
                            {(() => {
                              const bancos = Object.values(simulacao.simulacoes_bancos || {});
                              const hasPossibilidade = bancos.some(b => 
                                (b.valorLiberado && b.valorLiberado !== 'R$ 0,00' && !b.recusada) || 
                                (b.status === 'Aprovada')
                              );
                              
                              let info = { label: simulacao.status, color: '#666', bg: '#eee' };
                              
                              if (hasPossibilidade) {
                                info = { label: 'Com possibilidade', color: '#155724', bg: '#d4edda' };
                              } else if (simulacao.status === 'Em análise' || simulacao.status === 'Pendente' || bancos.some(b => !b.valorLiberado && !b.recusada)) {
                                info = { label: 'Em análise', color: '#004085', bg: '#cce5ff' };
                              } else if ((simulacao.status === 'Finalizada' || simulacao.status === 'Reprovada') && bancos.length > 0 && bancos.every(b => b.recusada)) {
                                info = { label: 'Recusada', color: '#721c24', bg: '#f8d7da' };
                              }

                              return (
                                <span style={{
                                  fontSize: '0.75rem',
                                  fontWeight: '600',
                                  padding: '4px 8px',
                                  borderRadius: '12px',
                                  background: info.bg,
                                  color: info.color,
                                  whiteSpace: 'nowrap'
                                }}>
                                  {info.label}
                                </span>
                              );
                            })()}
                          </td>
                          <td style={{ fontSize: '0.9rem', whiteSpace: 'nowrap' }}>
                            {formatarDataInteligente(simulacao.createdAt)}
                          </td>
                          <td style={{ textAlign: 'center' }}>
                            <button 
                              className="btn-small"
                              style={{
                                background: '#27ae60',
                                color: 'white',
                                padding: '5px',
                                border: 'none',
                                borderRadius: '4px',
                                cursor: 'pointer',
                                fontSize: '0.9rem',
                                fontWeight: '600',
                                transition: 'background 0.2s',
                                minWidth: '80px'
                              }}
                              onMouseEnter={(e) => e.target.style.background = '#229954'}
                              onMouseLeave={(e) => e.target.style.background = '#27ae60'}
                              onClick={() => {
                                // TODO: Abrir modal de análise da simulação
                                setMessage({ type: 'info', text: 'Funcionalidade em desenvolvimento!' });
                              }}
                            >
                               Iniciar
                            </button>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
                <Paginacao 
                  paginaAtual={paginaSimulacoes}
                  totalPags={totalPaginas(simulacoes)}
                  onPaginaChange={setPaginaSimulacoes}
                />
              </div>
            )}
          </div>
        );

      case 'cobrancas':
        return (
          <div className="content-section">
            <div className="page-header-mobile">
              <button 
                className="mobile-menu-toggle"
                onClick={() => setSidebarOpen(!sidebarOpen)}
              >
                ☰
              </button>
              <h1>Cobranças</h1>
            </div>

            <div className="section-actions">
              <input 
                type="search" 
                placeholder="Buscar por cliente, placa ou CPF..." 
                className="search-input"
                value={searchCobrancas}
                onChange={(e) => setSearchCobrancas(e.target.value)}
                style={{ flex: '1', maxWidth: 'none' }}
              />

              <div style={{ display: 'flex', gap: '10px' }}>
                <button 
                  className="btn-secondary"
                  onClick={() => setShowCalendarModal(true)}
                  style={{
                    padding: '12px 24px',
                    fontSize: '1rem',
                    fontWeight: '600',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px',
                    minWidth: 'auto',
                    backgroundColor: 'white',
                    color: '#3498db',
                    borderColor: '#3498db'
                  }}
                >
                  📅 Ver Calendário
                </button>

                <button 
                  className="btn-primary"
                  onClick={() => setShowCadastrarCobranca(true)}
                  style={{
                    padding: '12px 24px',
                    fontSize: '1rem',
                    fontWeight: '600',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px',
                    minWidth: 'auto'
                  }}
                >
                  Nova cobrança
                </button>
              </div>
            </div>

            <Cobrancas cobrancas={cobrancas} />

            {/* Modal Calendário Full Screen */}
            <CalendarioCobrancasModal 
              show={showCalendarModal}
              onClose={() => setShowCalendarModal(false)}
              cobrancas={cobrancas}
            />

            {/* Modal de Nova Cobrança - Hello World */}
            {showCadastrarCobranca && (
              <div style={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                background: 'rgba(0, 0, 0, 0.5)',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                zIndex: 9999
              }}>
                <div style={{
                  background: 'white',
                  borderRadius: '12px',
                  padding: '2rem',
                  maxWidth: '500px',
                  width: '90%',
                  textAlign: 'center'
                }}>
                  <h2 style={{ color: '#2c3e50', marginBottom: '1.5rem' }}>Nova Cobrança</h2>
                  <p style={{ marginBottom: '2rem' }}>Hello World ( ;</p>
                  <button 
                    className="btn-primary"
                    onClick={() => setShowCadastrarCobranca(false)}
                    style={{ width: '100%' }}
                  >
                    Fechar
                  </button>
                </div>
              </div>
            )}
          </div>
        );
      
      case 'negociacoes':
        return <Negociacoes onToggleSidebar={() => setSidebarOpen(!sidebarOpen)} negociacaoInicialId={negociacaoOrigemId} onNegociacaoInicialAberta={() => setNegociacaoOrigemId(null)} />;

      case 'analise':
        return (
          <Analise
            onToggleSidebar={() => setSidebarOpen(!sidebarOpen)}
            assuntoAtivo={analiseSubmenu}
            onAssuntoChange={setAnaliseSubmenu}
          />
        );
      
      case 'configuracoes': {
        // Se for Vendedor, forçar para a aba de simulações e esconder as outras
        // isVendedor já declarado no escopo do componente (linha 132)
        if (isVendedor && configSubmenu !== 'simulacoes') {
          // Usamos setTimeout para evitar loop de renderização infinita, 
          // mas idealmente isso seria controlado no estado inicial ou useEffect
        }

        return (
          <div className="content-section">
            <div className="page-header-mobile">
              <button 
                className="mobile-menu-toggle"
                onClick={() => setSidebarOpen(!sidebarOpen)}
              >
                ☰
              </button>
              <h1>Configurações</h1>
            </div>
            
            {/* Menu de navegação entre submenus */}
            <div className="configuracoes-mobile-tabs" style={{ 
              background: 'white', 
              padding: '1rem', 
              borderRadius: '8px',
              boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
              marginTop: '2rem',
              display: 'flex',
              gap: '1rem',
              flexWrap: 'wrap'
            }}>
              {!isVendedor && (
                <>
                  <button
                    onClick={() => setConfigSubmenu('usuarios')}
                    className={configSubmenu === 'usuarios' ? 'btn-primary' : 'btn-secondary'}
                  >
                    Usuários
                  </button>
                  {!lojaEhPremiumBeef && (
                    <>
                      <button
                        onClick={() => setConfigSubmenu('bancos')}
                        className={configSubmenu === 'bancos' ? 'btn-primary' : 'btn-secondary'}
                      >
                        Bancos
                      </button>
                      <button
                        onClick={() => setConfigSubmenu('fornecedores')}
                        className={configSubmenu === 'fornecedores' ? 'btn-primary' : 'btn-secondary'}
                      >
                        Fornecedores
                      </button>
                      <button
                        onClick={() => setConfigSubmenu('whatsapp')}
                        className={configSubmenu === 'whatsapp' ? 'btn-primary' : 'btn-secondary'}
                      >
                        WhatsApp
                      </button>
                      <button
                        onClick={() => setConfigSubmenu('estoque')}
                        className={configSubmenu === 'estoque' ? 'btn-primary' : 'btn-secondary'}
                      >
                        Estoque
                      </button>
                    </>
                  )}
                </>
              )}
              
               <button
                onClick={() => setConfigSubmenu('simulacoes')}
                className={configSubmenu === 'simulacoes' ? 'btn-primary' : 'btn-secondary'}
              >
                Simulações
              </button>

            </div>

             {/* Configurações de Simulações (Acessível a Vendedores) */}
             {configSubmenu === 'simulacoes' && (
              <div style={{ 
                background: 'white', 
                padding: '2rem', 
                borderRadius: '8px',
                boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                marginTop: '2rem'
              }}>
                <h2 style={{ color: '#333', marginBottom: '2rem' }}>Preferências de Simulação</h2>
                
                {/* Checkbox Ocultar Nomes dos Bancos */}
                <div style={{ marginBottom: '2rem', paddingBottom: '2rem', borderBottom: '1px solid #e0e0e0' }}>
                  <label style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', fontWeight: '500', cursor: 'pointer', fontSize: '15px' }}>
                    <input 
                      type="checkbox" 
                      checked={ocultarNomesBancos}
                      onChange={(e) => setOcultarNomesBancos(e.target.checked)}
                      style={{ cursor: 'pointer', width: '18px', height: '18px' }}
                    />
                    Ocultar nomes dos bancos
                  </label>
                  <p style={{ color: '#666', fontSize: '0.9rem', margin: '0.5rem 0 0 1.9rem' }}>
                    Exibir códigos em vez dos nomes (B1, B2, B3...)
                  </p>
                </div>
                
                <div style={{ marginBottom: '2rem' }}>
                  <label style={{ display: 'block', marginBottom: '0.75rem', fontWeight: '500', fontSize: '15px' }}>
                    GAP de Parcela
                  </label>
                  
                  <div style={{ position: 'relative', width: '200px' }}>
                    <span style={{ 
                      position: 'absolute', 
                      left: '12px', 
                      top: '50%', 
                      transform: 'translateY(-50%)', 
                      color: '#666',
                      fontWeight: 'bold'
                    }}>
                      R$
                    </span>
                    <input 
                      type="text" 
                      value={localGap}
                      placeholder="0"
                      onChange={(e) => {
                         // Campo livre - sem filtros
                         setLocalGap(e.target.value);
                      }}
                      style={{ 
                        width: '100%',
                        padding: '10px 12px 10px 40px',
                        border: '1px solid #ddd',
                        borderRadius: '6px',
                        fontSize: '16px',
                        outline: 'none',
                        boxShadow: 'inset 0 1px 2px rgba(0,0,0,0.05)',
                        fontWeight: 'bold'
                      }} 
                    />
                  </div>
                </div>

                <button
                  className="btn-primary"
                  onClick={async () => {
                     try {
                       // Sanitização ao SALVAR
                       // 1. Converte para string se não for
                       let gapStr = String(localGap || '');
                       
                       // 2. Remove tudo que não é número
                       gapStr = gapStr.replace(/\D/g, '');
                       
                       // 3. Converte para inteiro
                       let gapParaSalvar = parseInt(gapStr);
                       
                       // 4. Validações e Limites
                       if (isNaN(gapParaSalvar)) gapParaSalvar = 0;
                       if (gapParaSalvar > 500) gapParaSalvar = 500;
                       
                       // Atualizar estado local limpo
                       setLocalGap(gapParaSalvar);

                       const usuarioFinal = {
                         ...user,
                         permissoes: {
                           ...user.permissoes,
                           configuracoes_pessoais: {
                             ...user.permissoes?.configuracoes_pessoais,
                             gap_parcela: gapParaSalvar,
                             ocultarNomesBancos: ocultarNomesBancos
                           }
                         }
                       };
                       
                       // Persistir no localStorage (chave principal usada no login)
                       localStorage.setItem('user', JSON.stringify(usuarioFinal));
                       // Manter compatibilidade com usos antigos
                       localStorage.setItem('usuario', JSON.stringify(usuarioFinal));

                       // Enviar para backend
                       const token = localStorage.getItem('token');
                       const userId = user._id || user.id || user.userId;
                       
                       if (!userId) {
                         console.error('User object:', user);
                         throw new Error("ID do usuário não identificado");
                       }

                       await axios.put(`${API_CONFIG.API_URL}/usuarios/${userId}`, 
                         { 
                           gap_parcela: gapParaSalvar,
                           ocultarNomesBancos: ocultarNomesBancos
                         },
                         { headers: { 'x-auth-token': token } }
                       );
                       
                       setGapSavingSuccess(true);
                       setTimeout(() => setGapSavingSuccess(false), 2000);
                     } catch (err) {
                       console.error('Erro ao salvar preferências:', err);
                       setGapSavingSuccess(false);
                     }
                  }}
                  style={{ padding: '10px 32px' }}
                >
                  {gapSavingSuccess ? '✓ Salvo' : 'Salvar Preferências'}
                </button>

              </div>
             )}

            {/* Configuração de Usuários */}
            {configSubmenu === 'usuarios' && (
              <div style={{ 
                background: 'white', 
                padding: '2rem', 
                borderRadius: '8px',
                boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                marginTop: '2rem'
              }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.5rem' }}>
                  <h2 style={{ color: '#333', margin: 0 }}>Gerenciar Usuários</h2>
                  <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                    {user.gerenciar_acessos && <button type="button" className="btn-primary" onClick={() => setUsuarioAcessosId('todos')}>Gerenciar permissões</button>}
                    {(user.cargo === 'Gerente' || user.tipo === 'super_admin') && (
                      <button 
                        className="btn-primary"
                        onClick={() => setUsuarioParaEditar({
                          _id: null,
                          nome: '',
                          usuario: '',
                          cargo: '',
                          status: 'ativo',
                          permissoes: {
                            estoque: { visualizar: true, cadastrar: false, editar: false, excluir: false },
                            fichas: { criar: false, visualizar_proprias: true, visualizar_todas: false, editar_proprias: false, editar_todas: false, excluir: false, analisar: false, cancelar: false, preencher: false, enviar: false },
                            analise: { visualizar: false, gerencial: false, metas: false },
                            negociacoes: { visualizar: false, criar: false, editar: false, excluir: false },
                            documentacao: { visualizar: true },
                            configuracoes: { usuarios_config: false, whatsapp_config: false, bancos_config: false, lojas_config: false, veiculos_config: false, fornecedores_config: false }
                          },
                          informacoes_pessoais: {
                            whatsapp: '',
                            notificacoes_whatsapp: false
                          }
                        })}
                      >
                        Novo Usuário
                      </button>
                    )}
                  </div>
                </div>

                {user.gerenciar_acessos && usuarioAcessosId && (
                  <div id="usuario-acessos-painel" style={{ border: '1px solid #bfdbfe', borderRadius: 12, padding: '1rem', marginBottom: '1.5rem' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
                      <h3 style={{ margin: 0 }}>Permissões de menus</h3>
                      <button type="button" className="btn-secondary" onClick={() => setUsuarioAcessosId(null)}>Fechar acessos</button>
                    </div>
                    <AcessosUsuarios key={usuarioAcessosId} embedded usuarioId={usuarioAcessosId === 'todos' ? undefined : usuarioAcessosId} onAtualizar={atualizarAcessos} />
                  </div>
                )}
                <div className="section-actions" style={{ marginBottom: '2rem' }}>
                  <input 
                    type="search" 
                    placeholder="Buscar usuários..." 
                    className="search-input"
                    value={searchUsuarios}
                    onChange={(e) => setSearchUsuarios(e.target.value)}
                    style={{ flex: '1', maxWidth: 'none' }}
                  />
                </div>
                
                {loadingUsuarios ? (
                  <div className="loading">Carregando usuários...</div>
                ) : usuarios.length === 0 ? (
                  <div style={{ 
                    textAlign: 'center', 
                    padding: '3rem',
                    color: '#999',
                    fontSize: '1.1rem'
                  }}>
                    Nenhum usuário encontrado
                  </div>
                ) : (
                  <>
                    <div style={{
                      display: 'grid',
                      gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
                      gap: '1.5rem',
                      marginTop: '2rem'
                    }}>
                      {paginar(usuarios, paginaUsuarios, 12).map((usuario) => (
                        <div 
                          key={usuario._id}
                          onClick={() => buscarUsuarioCompleto(usuario._id)}
                          style={{
                            background: 'white',
                            borderRadius: '12px',
                            padding: '1.5rem',
                            boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                            cursor: 'pointer',
                            transition: 'all 0.3s ease',
                            border: '1px solid #e0e0e0'
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.transform = 'translateY(-4px)';
                            e.currentTarget.style.boxShadow = '0 4px 16px rgba(0,0,0,0.15)';
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.transform = 'translateY(0)';
                            e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.1)';
                          }}
                        >
                          {/* Header do Card */}
                          {user.gerenciar_acessos && !['super_admin', 'bps'].includes(usuario.tipo) && (
                            <button type="button" className="btn-secondary" aria-expanded={usuarioAcessosId === usuario._id} style={{ marginBottom: 12 }} onClick={e => { e.stopPropagation(); setUsuarioAcessosId(usuario._id); setTimeout(() => document.getElementById('usuario-acessos-painel')?.scrollIntoView({ behavior: 'smooth', block: 'start' }), 0); }}>
                              Permissões de acesso
                            </button>
                          )}
                          <div style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            marginBottom: '1rem',
                            paddingBottom: '1rem',
                            borderBottom: '2px solid #f0f0f0'
                          }}>
                            <span style={{
                              fontSize: '0.85rem',
                              fontWeight: '600',
                              padding: '4px 12px',
                              borderRadius: '20px',
                              background: usuario.cargo === 'Gerente' ? '#e3f2fd' : 
                                         usuario.cargo === 'Analista' ? '#fff3e0' : '#f3e5f5',
                              color: usuario.cargo === 'Gerente' ? '#1976d2' : 
                                     usuario.cargo === 'Analista' ? '#f57c00' : '#7b1fa2'
                            }}>
                              {usuario.cargo}
                            </span>
                            <span style={{
                              fontSize: '0.75rem',
                              padding: '4px 10px',
                              borderRadius: '12px',
                              background: usuario.status === 'ativo' ? '#e8f5e9' : '#ffebee',
                              color: usuario.status === 'ativo' ? '#2e7d32' : '#c62828',
                              fontWeight: '600'
                            }}>
                              {usuario.status === 'ativo' ? 'Ativo' : 'Inativo'}
                            </span>
                          </div>

                          {/* Body do Card */}
                          <div style={{ marginBottom: '1rem' }}>
                            <div style={{
                              fontSize: '1.1rem',
                              fontWeight: '600',
                              color: '#333',
                              marginBottom: '0.5rem'
                            }}>
                              {usuario.nome}
                            </div>
                            <div style={{
                              fontSize: '0.9rem',
                              color: '#666',
                              marginBottom: '0.25rem'
                            }}>
                              👤 {usuario.usuario}
                            </div>
                            {usuario.email && (
                              <div style={{
                                fontSize: '0.85rem',
                                color: '#888',
                                marginBottom: '0.25rem'
                              }}>
                                ✉️ {usuario.email}
                              </div>
                            )}
                          </div>

                          {/* Footer do Card */}
                          <div style={{
                            paddingTop: '1rem',
                            borderTop: '1px solid #f0f0f0',
                            fontSize: '0.8rem',
                            color: '#999'
                          }}>
                            {usuario.ultimo_login ? (
                              <>
                                🕐 Último acesso: {formatarDataInteligente(usuario.ultimo_login)}
                              </>
                            ) : (
                              '🕐 Nunca acessou'
                            )}
                          </div>
                        </div>
                      ))}
                    </div>
                    <Paginacao 
                      paginaAtual={paginaUsuarios}
                      totalPags={totalPaginas(usuarios, 12)}
                      onPaginaChange={setPaginaUsuarios}
                    />
                  </>
                )}
              </div>
            )}

            {/* Configuração de Bancos */}
            {configSubmenu === 'bancos' && (
              <div style={{ 
                background: 'white', 
                padding: '2rem', 
                borderRadius: '8px',
                boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                marginTop: '2rem'
              }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.5rem' }}>
                  <h2 style={{ color: '#333', margin: 0 }}>Bancos para Simulação</h2>
                  <div style={{ display: 'flex', gap: '10px' }}>
                    <button
                      onClick={() => abrirModalBanco()}
                      className="btn-primary"
                    >
                      Cadastrar banco
                    </button>
                  </div>
                </div>
                
                <p style={{ color: '#666', marginBottom: '2rem', lineHeight: '1.6' }}>
                  Configure os bancos que aparecerão nas simulações de financiamento.
                </p>
                
                {bancos.length === 0 ? (
                  <div style={{ 
                    textAlign: 'center', 
                    padding: '3rem', 
                    color: '#999',
                    border: '2px dashed #e0e0e0',
                    borderRadius: '8px',
                    background: '#f8f9fa'
                  }}>
                    Nenhum banco cadastrado
                  </div>
                ) : (
                  <div style={{ 
                    display: 'grid',
                    gap: '1rem'
                  }}>
                    {bancos.filter(b => b.ativo).map((banco) => (
                      <div
                        key={banco._id}
                        style={{
                          padding: '1.5rem',
                          border: '1px solid #e0e0e0',
                          borderRadius: '8px',
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center'
                        }}
                      >
                        <div>
                          <div style={{ 
                            fontWeight: '600', 
                            color: '#333',
                            marginBottom: '8px',
                            fontSize: '16px'
                          }}>
                            {banco.nome}
                          </div>
                          {banco.codigo_banco && (
                            <div style={{ fontSize: '13px', color: '#666', marginBottom: '4px' }}>
                              🔑 Chave: <code style={{ background: '#f0f0f0', padding: '2px 6px', borderRadius: '4px' }}>{banco.codigo_banco}</code>
                            </div>
                          )}
                          {banco.login && (
                            <div style={{ fontSize: '14px', color: '#999' }}>
                              Login principal: {banco.login} · {banco.acessos?.length || 1} acesso(s)
                            </div>
                          )}
                        </div>
                        <button
                          onClick={() => abrirModalBanco(banco)}
                          className="btn-primary"
                        >
                          Editar
                        </button>
                      </div>
                    ))}
                  </div>
                )}

                {/* Botão de Download do Instalador */}
                <div style={{ 
                  marginTop: '2rem',
                  paddingTop: '2rem',
                  borderTop: '2px solid #e0e0e0',
                  display: 'flex',
                  justifyContent: 'center'
                }}>
                  <button
                    onClick={() => {
                      const link = document.createElement('a');
                      link.href = `${API_CONFIG.API_URL.replace('/api', '')}/api/download/vetim-installer`;
                      link.download = 'Vetim.exe';
                      document.body.appendChild(link);
                      link.click();
                      document.body.removeChild(link);
                    }}
                    style={{
                      padding: '12px 32px',
                      backgroundColor: '#4CAF50',
                      color: 'white',
                      border: 'none',
                      borderRadius: '6px',
                      fontSize: '16px',
                      fontWeight: 'bold',
                      cursor: 'pointer',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '8px',
                      transition: 'background-color 0.3s ease'
                    }}
                    onMouseEnter={(e) => e.target.style.backgroundColor = '#45a049'}
                    onMouseLeave={(e) => e.target.style.backgroundColor = '#4CAF50'}
                  >
                    📥 Baixar Instalador VETIM
                  </button>
                </div>
              </div>
            )}

            {/* Configuração de Fornecedores */}
            {configSubmenu === 'fornecedores' && (
              <div style={{ 
                background: 'white', 
                padding: '2rem', 
                borderRadius: '8px',
                boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                marginTop: '2rem'
              }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.5rem' }}>
                  <h2 style={{ color: '#333', margin: 0 }}>Fornecedores</h2>
                  <button
                    onClick={() => {
                      setFornecedorParaEditar(null);
                      setShowCadastrarFornecedor(true);
                    }}
                    className="btn-primary"
                  >
                    Cadastrar Fornecedor
                  </button>
                </div>

                <p style={{ color: '#666', marginBottom: '2rem', lineHeight: '1.6' }}>
                  Gerencie os fornecedores de veículos. Os fornecedores podem ser associados aos veículos no estoque.
                </p>

                {fornecedores.length === 0 ? (
                  <div style={{ 
                    textAlign: 'center', 
                    padding: '3rem', 
                    color: '#999',
                    border: '2px dashed #e0e0e0',
                    borderRadius: '8px',
                    background: '#f8f9fa'
                  }}>
                    Nenhum fornecedor cadastrado
                  </div>
                ) : (
                  <div style={{ 
                    display: 'grid',
                    gap: '1rem'
                  }}>
                    {fornecedores.filter(f => f.ativo).map((fornecedor) => (
                      <div
                        key={fornecedor._id}
                        style={{
                          padding: '1.5rem',
                          border: '1px solid #e0e0e0',
                          borderRadius: '8px',
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center'
                        }}
                      >
                        <div>
                          <div style={{ 
                            fontWeight: '600', 
                            color: '#333',
                            marginBottom: '8px',
                            fontSize: '16px'
                          }}>
                            {fornecedor.nome}
                          </div>
                          <div style={{ fontSize: '14px', color: '#666', marginBottom: '4px' }}>
                            {fornecedor.tipo}
                            {fornecedor.cpf_cnpj && ` • ${fornecedor.cpf_cnpj}`}
                          </div>
                          {fornecedor.telefone && (
                            <div style={{ fontSize: '14px', color: '#999' }}>
                              Telefone: {fornecedor.telefone}
                            </div>
                          )}
                        </div>
                        <button
                          onClick={() => {
                            setFornecedorParaEditar(fornecedor);
                            setShowCadastrarFornecedor(true);
                          }}
                          className="btn-primary"
                        >
                          Editar
                        </button>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            )}

            {/* Configuração de WhatsApp */}
            {configSubmenu === 'whatsapp' && (
              <div style={{ 
                background: 'white', 
                padding: '2rem', 
                borderRadius: '8px',
                boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                marginTop: '2rem'
              }}>
                <h2 style={{ color: '#333', marginBottom: '1.5rem' }}>Integração WhatsApp</h2>
                
                <p style={{ color: '#666', marginBottom: '2rem', lineHeight: '1.6' }}>
                  Conecte seu WhatsApp para enviar mensagens automáticas aos usuários.
                </p>

                {/* Status de conexão */}
                <div style={{
                  padding: '1.5rem',
                  background: whatsappStatus === 'connected' ? '#d4edda' : 
                             whatsappStatus === 'initializing' ? '#fff3cd' : '#f8f9fa',
                  border: `2px solid ${whatsappStatus === 'connected' ? '#27ae60' : 
                                       whatsappStatus === 'initializing' ? '#f39c12' : '#e0e0e0'}`,
                  borderRadius: '8px',
                  marginBottom: '2rem'
                }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', justifyContent: 'space-between' }}>
                    <div style={{ flex: 1 }}>
                      {whatsappStatus === 'initializing' && (
                        <div style={{
                          display: 'inline-block',
                          width: '20px',
                          height: '20px',
                          border: '3px solid #f39c12',
                          borderTop: '3px solid transparent',
                          borderRadius: '50%',
                          animation: 'spin 1s linear infinite',
                          marginRight: '1rem',
                          verticalAlign: 'middle'
                        }}></div>
                      )}
                      {whatsappStatus === 'connected' && (
                        <span style={{ fontSize: '1.5rem', marginRight: '1rem', verticalAlign: 'middle' }}>✅</span>
                      )}
                      <h3 style={{ margin: 0, marginBottom: '0.5rem', color: '#333' }}>
                        Status: {
                          whatsappStatus === 'connected' ? 'Conectado' :
                          whatsappStatus === 'initializing' ? 'Carregando' :
                          whatsappStatus === 'qr' ? 'Aguardando QR Code' :
                          'Desconectado'
                        }
                      </h3>
                      {whatsappInfo && whatsappStatus === 'connected' && (
                        <>
                          <p style={{ margin: 0, color: '#666', fontSize: '0.95rem' }}>
                            Conectado como: <strong>{whatsappInfo.pushname || whatsappInfo.user}</strong>
                          </p>
                          {whatsappInfo.wid && (
                            <p style={{ margin: 0, color: '#666', fontSize: '0.95rem', marginTop: '0.25rem' }}>
                              Telefone: <strong>{whatsappInfo.wid.user}</strong>
                            </p>
                          )}
                        </>
                      )}
                      {whatsappStatus === 'disconnected' && (
                        <p style={{ margin: 0, color: '#666', fontSize: '0.95rem' }}>
                          Clique em "Conectar WhatsApp" para iniciar a conexão
                        </p>
                      )}
                      {whatsappStatus === 'initializing' && (
                        <p style={{ margin: 0, color: '#666', fontSize: '0.95rem' }}>
                          Inicializando WhatsApp Web, aguarde...
                        </p>
                      )}
                    </div>
                    
                    {/* Botão de ação */}
                    <div>
                      {whatsappStatus === 'disconnected' ? (
                        <button
                          onClick={inicializarWhatsApp}
                          disabled={loading}
                          style={{
                            padding: '12px 24px',
                            background: '#27ae60',
                            color: 'white',
                            border: 'none',
                            borderRadius: '6px',
                            cursor: loading ? 'not-allowed' : 'pointer',
                            fontWeight: '600',
                            fontSize: '1rem',
                            opacity: loading ? 0.6 : 1,
                            whiteSpace: 'nowrap'
                          }}
                        >
                          {loading ? 'Conectando...' : 'Conectar WhatsApp'}
                        </button>
                      ) : (
                        <button
                          onClick={desconectarWhatsApp}
                          disabled={loading}
                          style={{
                            padding: '12px 24px',
                            background: '#e74c3c',
                            color: 'white',
                            border: 'none',
                            borderRadius: '6px',
                            cursor: loading ? 'not-allowed' : 'pointer',
                            fontWeight: '600',
                            fontSize: '1rem',
                            opacity: loading ? 0.6 : 1,
                            whiteSpace: 'nowrap'
                          }}
                        >
                          {loading ? 'Desconectando...' : 'Desconectar'}
                        </button>
                      )}
                    </div>
                  </div>
                </div>

                {/* QR Code */}
                {whatsappStatus === 'qr' && (
                  <div style={{
                    padding: '2rem',
                    background: '#f8f9fa',
                    border: '2px dashed #c14427',
                    borderRadius: '8px',
                    textAlign: 'center',
                    marginBottom: '2rem'
                  }}>
                    <h3 style={{ color: '#333', marginBottom: '1rem' }}>Escaneie o QR Code</h3>
                    <p style={{ color: '#666', marginBottom: '1.5rem' }}>
                      Abra o WhatsApp no seu celular e escaneie o código abaixo
                    </p>
                    {whatsappQR ? (
                      <div style={{ 
                        display: 'inline-block',
                        padding: '1rem',
                        background: 'white',
                        borderRadius: '8px',
                        boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
                      }}>
                        <img 
                          src={whatsappQR} 
                          alt="QR Code WhatsApp" 
                          style={{ 
                            maxWidth: '300px',
                            width: '100%',
                            height: 'auto'
                          }}
                        />
                      </div>
                    ) : (
                      <div style={{ 
                        padding: '3rem',
                        color: '#999'
                      }}>
                        <div style={{ fontSize: '3rem', marginBottom: '1rem' }}></div>
                        Gerando QR Code...
                      </div>
                    )}
                  </div>
                )}
              </div>
            )}

            {/* Configuração de Estoque */}
            {configSubmenu === 'estoque' && (
              <div style={{ 
                background: 'white', 
                padding: '2rem', 
                borderRadius: '8px',
                boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                marginTop: '2rem'
              }}>
                <h2 style={{ color: '#333', marginBottom: '1.5rem' }}>Sincronização de Estoque</h2>
                
                <p style={{ color: '#666', marginBottom: '2rem', lineHeight: '1.6' }}>
                  O estoque é atualizado automaticamente a cada 60 minutos entre as 06:00 e 00:00.
                  Você também pode forçar uma atualização manual abaixo.
                </p>

                <div style={{
                  padding: '2rem',
                  background: '#f8f9fa',
                  borderRadius: '12px',
                  border: '1px solid #e0e0e0',
                  textAlign: 'center'
                }}>
                  <div style={{ marginBottom: '2rem' }}>
                    <div style={{ fontSize: '0.9rem', color: '#666', marginBottom: '0.5rem' }}>Última sincronização bem-sucedida:</div>
                    <div style={{ fontSize: '1.2rem', fontWeight: 'bold', color: '#2c3e50' }}>
                      {loadingStatusSync ? '⏳ Carregando...' : (ultimaSyncEstoque ? formatarDataInteligente(ultimaSyncEstoque) : 'Nunca sincronizado')}
                    </div>
                  </div>

                  <button
                    onClick={handleSincronizar}
                    disabled={loadingSync}
                    className="btn-primary"
                    style={{
                      padding: '12px 32px',
                      fontSize: '1rem',
                      fontWeight: 'bold',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '10px',
                      margin: '0 auto',
                      background: loadingSync ? '#95a5a6' : '#3498db'
                    }}
                  >
                    {loadingSync ? '⏳ Sincronizando...' : '🔄 Forçar atualização de estoque'}
                  </button>

                  <div style={{ marginTop: '1.5rem', fontSize: '0.85rem', color: '#999' }}>
                    * Veículos removidos do Autocerto serão automaticamente retirados do sistema VETIM.
                  </div>
                </div>
              </div>
            )}

          </div>

        );
      }
      
      default:
        return <div>Página não encontrada</div>;
    }
  };

  return (
    <div className="dashboard">
      <Sidebar 
        activeMenu={activeMenu}
        setActiveMenu={setActiveMenu}
        user={user}
        onLogout={onLogout}
        isOpen={sidebarOpen}
        toggleSidebar={() => setSidebarOpen(!sidebarOpen)}
        contextoLoja={lojaContexto}
        setAnaliseSubmenu={setAnaliseSubmenu}
      />
      <div className={`main-content ${sidebarOpen ? 'sidebar-open' : ''}`}>
        
        {/* Banner de Contexto de Loja - Apenas para Super Admin */}
        {lojaContexto && user.tipo === 'super_admin' && (
          <div style={{
            background: '#2d3748',
            color: 'white',
            padding: '10px 20px',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: '20px',
            borderRadius: '8px',
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
          }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <span style={{ fontSize: '20px' }}>👁️</span>
              <div>
                <div style={{ fontSize: '12px', opacity: 0.8 }}>Modo de Visualização</div>
                <div style={{ fontWeight: 'bold' }}>{lojaContexto.nome}</div>
              </div>
            </div>
            <button
              onClick={() => {
                localStorage.removeItem('lojaContexto');
                setLojaContexto(null);
                window.location.href = '/admin/lojas';
              }}
              style={{
                background: '#e53e3e',
                color: 'white',
                border: 'none',
                padding: '6px 12px',
                borderRadius: '4px',
                cursor: 'pointer',
                fontSize: '13px'
              }}
            >
              Sair desta Loja
            </button>
          </div>
        )}

        {/* Botão Flutuante de Notificações */}
        <div 
          className="notificacoes-floating"
          style={{ 
            position: 'fixed',
            bottom: '2rem',
            right: '2rem',
            zIndex: 1000
          }}
        >
          <div style={{ position: 'relative' }}>
            <button
              onClick={() => {
                setShowNotificacoes(!showNotificacoes);
                if (!showNotificacoes) {
                  carregarNotificacoes();
                }
              }}
              style={{
                background: 'linear-gradient(135deg, #3498db 0%, #2980b9 100%)',
                border: 'none',
                borderRadius: '50%',
                cursor: 'pointer',
                fontSize: '1.8rem',
                position: 'relative',
                padding: '1rem',
                width: '60px',
                height: '60px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                boxShadow: '0 4px 12px rgba(52, 152, 219, 0.4)',
                transition: 'all 0.3s ease',
                filter: showNotificacoes ? 'brightness(1.1)' : 'brightness(1)'
              }}
              onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.1)'}
              onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
            >
              <span style={{ filter: 'brightness(0) invert(1)' }}>🔔</span>
              {contadorNotificacoes > 0 && (
                <span style={{
                  position: 'absolute',
                  top: '-5px',
                  right: '-5px',
                  background: '#e74c3c',
                  color: 'white',
                  borderRadius: '50%',
                  width: '24px',
                  height: '24px',
                  fontSize: '0.75rem',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontWeight: 'bold',
                  border: '2px solid white',
                  boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
                }}>
                  {contadorNotificacoes > 9 ? '9+' : contadorNotificacoes}
                </span>
              )}
            </button>

            {/* Painel de Notificações */}
            {showNotificacoes && (
              <div 
                className="notificacoes-panel"
                style={{
                  position: 'absolute',
                  bottom: '70px',
                  right: '0',
                  width: '400px',
                  maxHeight: '500px',
                  background: 'white',
                  boxShadow: '0 8px 24px rgba(0,0,0,0.2)',
                  borderRadius: '12px',
                  zIndex: 999,
                  overflow: 'hidden',
                  animation: 'slideUp 0.3s ease'
                }}
              >
                <div style={{
                  padding: '1rem',
                  borderBottom: '2px solid #e0e0e0',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  background: '#f8f9fa'
                }}>
                  <h3 style={{ margin: 0, fontSize: '1.1rem', color: '#333' }}>Notificações</h3>
                  <div style={{ display: 'flex', gap: '1rem', alignItems: 'center' }}>
                    {contadorNotificacoes > 0 && (
                      <button
                        onClick={marcarTodasLidas}
                        style={{
                          background: 'none',
                          border: 'none',
                          color: '#3498db',
                          cursor: 'pointer',
                          fontSize: '0.85rem',
                          fontWeight: '600'
                        }}
                      >
                        Marcar todas como lidas
                      </button>
                    )}
                    <button
                      className="close-notificacoes-mobile"
                      onClick={() => setShowNotificacoes(false)}
                      style={{
                        background: 'none',
                        border: 'none',
                        fontSize: '1.5rem',
                        cursor: 'pointer',
                        color: '#666',
                        display: 'none',
                        padding: '0',
                        lineHeight: '1'
                      }}
                    >
                      ×
                    </button>
                  </div>
                </div>
                
                <div 
                  className="notificacoes-list"
                  style={{
                    maxHeight: '400px',
                    overflowY: 'auto'
                  }}
                >
                  {notificacoes.length === 0 ? (
                    <div style={{
                      padding: '2rem',
                      textAlign: 'center',
                      color: '#999'
                    }}>
                      Nenhuma notificação
                    </div>
                  ) : (
                    notificacoes.map((notif) => (
                      <div
                        key={notif._id}
                        style={{
                          padding: '1rem',
                          borderBottom: '1px solid #e0e0e0',
                          background: notif.lida ? 'white' : '#e3f2fd',
                          cursor: 'pointer',
                          transition: 'background 0.2s'
                        }}
                        onClick={async (e) => {
                          e.stopPropagation();
                          
                          try {
                            // Marcar como lida se ainda não foi
                            if (!notif.lida) {
                              await marcarComoLida(notif._id);
                            }
                            
                            // Redirecionar se houver link
                            if (notif.link) {
                              const menuMap = {
                                '/fichas': 'fichas',
                                '/estoque': 'estoque',
                                '/configuracoes': 'configuracoes'
                              };
                              
                              
                              if (menuId) {
                                setActiveMenu(menuId);
                                setShowNotificacoes(false);
                              } else {
                              }
                            } else {
                            }
                          } catch (error) {
                          }
                        }}
                        onMouseEnter={(e) => e.currentTarget.style.background = notif.lida ? '#f8f9fa' : '#bbdefb'}
                        onMouseLeave={(e) => e.currentTarget.style.background = notif.lida ? 'white' : '#e3f2fd'}
                      >
                        <div style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                          marginBottom: '0.5rem'
                        }}>
                          <strong style={{ 
                            fontSize: '0.9rem',
                            color: '#333',
                            flex: 1
                          }}>
                            {notif.titulo}
                          </strong>
                          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                            {!notif.lida && (
                              <span style={{
                                width: '8px',
                                height: '8px',
                                background: '#2196f3',
                                borderRadius: '50%'
                              }} />
                            )}
                            <button
                              onClick={(e) => {
                                e.stopPropagation();
                                excluirNotificacao(notif._id);
                              }}
                              style={{
                                background: 'none',
                                border: 'none',
                                cursor: 'pointer',
                                fontSize: '1.2rem',
                                color: '#e74c3c',
                                padding: '4px',
                                display: 'flex',
                                alignItems: 'center',
                                opacity: 0.7,
                                transition: 'opacity 0.2s'
                              }}
                              onMouseEnter={(e) => e.currentTarget.style.opacity = '1'}
                              onMouseLeave={(e) => e.currentTarget.style.opacity = '0.7'}
                              title="Excluir notificação"
                            >
                              ×
                            </button>
                          </div>
                        </div>
                        <p style={{
                          margin: '0 0 0.5rem 0',
                          fontSize: '0.85rem',
                          color: '#666'
                        }}
                        dangerouslySetInnerHTML={{
                          __html: notif.mensagem.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')
                        }}
                        />
                        <small style={{
                          color: '#999',
                          fontSize: '0.75rem'
                        }}>
                          {formatarDataInteligente(notif.createdAt)}
                        </small>
                      </div>
                    ))
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
        
        <div className={`content content-${activeMenu}`}>
          {renderContent()}
        </div>
        
        {/* Modal para Nova Ficha */}
        {showNovaFicha && (
          <NovaFicha 
            isOpen={showNovaFicha}
            onClose={() => setShowNovaFicha(false)}
            user={user}
            onSubmit={async (fichaData) => {
              try {
                const token = localStorage.getItem('token');
                const response = await axios.post(`${API_CONFIG.API_URL}/fichas`, fichaData, {
                  headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                  }
                });
                if (response.data.success) {
                  setShowNovaFicha(false);
                  carregarFichas(); // Recarrega a lista após salvar
                  carregarEstatisticas(); // Recarrega estatísticas
                  setMessage({ type: 'success', text: 'Ficha criada com sucesso!' });
                } else {
                  setMessage({ type: 'error', text: response.data.message || 'Erro ao criar ficha' });
                  return false;
                }
              } catch (error) {
                let errorMessage = 'Erro ao conectar com o servidor';
                if (error.response && error.response.data && error.response.data.message) {
                  errorMessage = error.response.data.message;
                } else if (error.response && error.response.status === 401) {
                  onLogout();
                  return;
                }
                setMessage({ type: 'error', text: errorMessage });
                return false;
              }
            }}
          />
        )}

        {/* Modal para Listar Todas as Fichas */}
        {showModalFichas && (
          <ModalFichas
            isOpen={showModalFichas}
            onClose={() => setShowModalFichas(false)}
            onEditarFicha={(ficha) => {
              setShowModalFichas(false);
              setVoltarParaModalFichas(true);
              setFichaParaPreencher(ficha);
            }}
            onNovaFicha={() => {
              setShowModalFichas(false);
              setShowNovaFicha(true);
            }}
            userLogado={user}
          />
        )}
        
        {/* Modal para Preencher Ficha */}
        {fichaParaPreencher && (
          <PreencherFicha
            isOpen={!!fichaParaPreencher}
            onClose={() => {
              setFichaParaPreencher(null);
              // Se veio do modal de fichas, reabrir
              if (voltarParaModalFichas) {
                setShowModalFichas(true);
                setVoltarParaModalFichas(false);
              }
            }}
            ficha={fichaParaPreencher}
            userLogado={user}
            onSuccess={(message) => {
              carregarFichas();
              carregarEstatisticas();
              setMessage({ type: 'success', text: message });
              // Reabrir modal de fichas após sucesso
              setFichaParaPreencher(null);
              if (voltarParaModalFichas) {
                setShowModalFichas(true);
                setVoltarParaModalFichas(false);
              }
            }}
          />
        )}

        {/* Modal para Simulações */}
        {fichaParaSimulacao && (
          <Simulacoes
            ficha={fichaParaSimulacao}
            onClose={() => setFichaParaSimulacao(null)}
            onEditarFicha={(ficha) => {
              // Fechar simulação antes de abrir edição
              setFichaParaSimulacao(null);
              setFichaParaPreencher(ficha);
            }}
            onSave={() => {
              carregarFichas();
              setMessage({ type: 'success', text: 'Simulação salva com sucesso!' });
            }}
          />
        )}

        {/* Modal para Editar Usuário */}
        {usuarioParaEditar && (
          <EditarUsuario
            usuario={usuarioParaEditar}
            userLogado={user}
            onConfigurarPermissoes={id => {
              if (!window.confirm('Abrir as permissões? Alterações ainda não salvas neste formulário serão descartadas.')) return;
              setUsuarioParaEditar(null);
              setUsuarioAcessosId(id);
              setConfigSubmenu('usuarios');
              setActiveMenu('configuracoes');
              setTimeout(() => document.getElementById('usuario-acessos-painel')?.scrollIntoView({ behavior: 'smooth', block: 'start' }), 0);
            }}
            onClose={() => setUsuarioParaEditar(null)}
            onSave={(msg) => {
              carregarUsuarios();
              if (msg && msg.type) {
                setMessage(msg);
              } else {
                setMessage({ type: 'success', text: 'Usuário atualizado com sucesso!' });
              }
            }}
          />
        )}

        {showBpsModal && (
          <div className="modal-overlay-preencher" style={{ padding: 0 }}>
            <div className="modal-preencher-container" style={{ width: '100%', maxWidth: '520px', borderRadius: '16px' }} onClick={(e) => e.stopPropagation()}>
              <div className="modal-preencher-header">
                <h2>Novo acesso BPS</h2>
                <button className="modal-close-btn" onClick={() => setShowBpsModal(false)}>×</button>
              </div>
              <form
                onSubmit={async (e) => {
                  e.preventDefault();
                  setSalvandoBps(true);
                  try {
                    const token = localStorage.getItem('token');
                    await axios.post(`${API_CONFIG.API_URL}/usuarios`, {
                      nome: formBps.usuario,
                      usuario: formBps.usuario,
                      cargo: 'BPS',
                      tipo: 'bps',
                      senha: formBps.senha,
                      loja_id: null
                    }, {
                      headers: { Authorization: `Bearer ${token}` }
                    });
                    setMessage({ type: 'success', text: 'Acesso BPS criado com sucesso!' });
                    setFormBps({ usuario: '', senha: '' });
                    setShowBpsModal(false);
                    carregarUsuarios();
                  } catch (error) {
                    setMessage({ type: 'error', text: error.response?.data?.message || 'Erro ao criar acesso BPS' });
                  } finally {
                    setSalvandoBps(false);
                  }
                }}
                style={{ padding: '24px', display: 'flex', flexDirection: 'column', gap: '16px' }}
              >
                <div className="form-group">
                  <label>Usuário *</label>
                  <input
                    type="text"
                    required
                    value={formBps.usuario}
                    onChange={(e) => setFormBps(prev => ({ ...prev, usuario: e.target.value }))}
                    placeholder="ex: bps.sorocaba"
                    style={{ width: '100%', padding: '12px', borderRadius: '10px', border: '1px solid #cbd5e1' }}
                  />
                </div>
                <div className="form-group">
                  <label>Senha *</label>
                  <input
                    type="password"
                    required
                    value={formBps.senha}
                    onChange={(e) => setFormBps(prev => ({ ...prev, senha: e.target.value }))}
                    placeholder="mínimo 6 caracteres"
                    style={{ width: '100%', padding: '12px', borderRadius: '10px', border: '1px solid #cbd5e1' }}
                  />
                </div>
                <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
                  <button type="button" onClick={() => setShowBpsModal(false)} style={{ padding: '10px 16px', borderRadius: '10px', border: '1px solid #cbd5e1', background: '#fff', cursor: 'pointer' }}>Cancelar</button>
                  <button type="submit" disabled={salvandoBps} className="btn-primary" style={{ padding: '10px 16px' }}>
                    {salvandoBps ? 'Salvando...' : 'Criar acesso'}
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}

        {/* Modal para Cadastrar/Editar Veículo */}
        {showCadastrarVeiculo && (
          <CadastrarVeiculoModal
            veiculo={veiculoParaEditar}
            onClose={() => {
              setShowCadastrarVeiculo(false);
              setVeiculoParaEditar(null);
            }}
            onSave={(veiculo) => {
              // Se o callback recebeu um objeto com sucesso/mensagem (erro)
              if (veiculo && veiculo.success === false) {
                setMessage({ type: 'error', text: veiculo.message || 'Erro ao salvar veículo' });
                return;
              }
              
              carregarVeiculos();
              setMessage({ 
                type: 'success', 
                text: veiculoParaEditar ? 'Veículo atualizado com sucesso!' : 'Veículo cadastrado com sucesso!' 
              });
              setVeiculoParaEditar(null);
            }}
            onDelete={excluirVeiculo}
            userLogado={user}
            onVerJornada={abrirJornada}
            onToggleSeguir={toggleSeguirVeiculo}
            seguindo={veiculoParaEditar && user && user.id ? (veiculoParaEditar.seguidores || []).some(seg => seg && String(seg) === String(user.id)) : false}
          />
        )}

        {showCadastrarFornecedor && (
          <CadastrarFornecedorModal
            fornecedorEdit={fornecedorParaEditar}
            onClose={() => {
              setShowCadastrarFornecedor(false);
              setFornecedorParaEditar(null);
            }}
            onFornecedorCriado={() => {
              carregarFornecedores();
              setMessage({ 
                type: 'success', 
                text: fornecedorParaEditar ? 'Fornecedor atualizado com sucesso!' : 'Fornecedor cadastrado com sucesso!' 
              });
            }}
          />
        )}

        {/* Modal para Visualizar Jornada do Veículo */}
        {showJornada && veiculoJornadaId && (
          <JornadaVeiculoModal
            veiculoId={veiculoJornadaId}
            onClose={() => {
              setShowJornada(false);
              setVeiculoJornadaId(null);
            }}
          />
        )}

        {/* Modal de Cadastro/Edição de Banco */}
        {showModalBanco && (
          <div 
            className="modal-overlay-preencher"
          >
            <div 
              className="modal-content simulacoes-modal"
              onClick={(e) => e.stopPropagation()}
              style={{
                width: '90%',
                maxWidth: '500px',
                background: 'white'
              }}
            >
              <div className="modal-preencher-header">
                <h2>{bancoEditando ? 'Editar Banco' : 'Cadastrar Novo Banco'}</h2>
                <button className="modal-close-btn" onClick={fecharModalBanco}>×</button>
              </div>
              
              <form onSubmit={salvarBanco} style={{ padding: '2rem' }}>
                {user?.tipo === 'super_admin' && !lojaContexto && (
                  <div style={{
                    marginBottom: '1rem',
                    padding: '0.75rem',
                    background: '#fff3cd',
                    border: '1px solid #ffeeba',
                    borderRadius: '6px',
                    color: '#856404',
                    fontSize: '0.9rem',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center'
                  }}>
                    <div>
                      ⚠️ <strong>Nenhuma loja selecionada!</strong><br/>
                      Para cadastrar um banco, acesse <strong>Configurações → Gerenciar Lojas</strong>, selecione uma loja com o botão <strong>🔗 Acessar</strong> e retorne aqui.
                    </div>
                    <button onClick={() => window.location.href = '/admin/lojas'} style={{
                      background: '#ffc107',
                      border: 'none',
                      padding: '0.5rem 1rem',
                      borderRadius: '4px',
                      cursor: 'pointer',
                      fontWeight: '600',
                      fontSize: '0.85rem',
                      whiteSpace: 'nowrap',
                      marginLeft: '1rem',
                      color: '#333'
                    }}>
                      🔗 Ir para Lojas
                    </button>
                  </div>
                )}

                <div style={{ marginBottom: '1rem' }}>
                  <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '600', color: '#333' }}>
                    Nome do Banco *
                  </label>
                  <input
                    type="text"
                    value={formBanco.nome}
                    onChange={(e) => setFormBanco({ ...formBanco, nome: e.target.value })}
                    placeholder="Ex: Banco Santander"
                    required
                    style={{
                      width: '100%',
                      padding: '0.75rem',
                      border: '1px solid #ddd',
                      borderRadius: '6px',
                      fontSize: '1rem'
                    }}
                  />
                </div>

                <div style={{ marginBottom: '1rem' }}>
                  <label style={{ display: 'flex', alignItems: 'center', marginBottom: '0.5rem', fontWeight: '600', color: '#333', gap: '0.5rem' }}>
                    Chave de Sincronização
                    <button
                      type="button"
                      onClick={() => setShowTabelaBancosReferencia(true)}
                      title="Ver tabela de referência de bancos padrão"
                      style={{
                        background: 'none',
                        border: 'none',
                        cursor: 'pointer',
                        fontSize: '1.2rem',
                        padding: '0',
                        color: '#666',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: '20px',
                        height: '20px',
                        borderRadius: '50%',
                        backgroundColor: '#e8e8e8',
                        transition: 'background-color 0.2s'
                      }}
                      onMouseEnter={(e) => e.target.style.backgroundColor = '#d0d0d0'}
                      onMouseLeave={(e) => e.target.style.backgroundColor = '#e8e8e8'}
                    >
                      ?
                    </button>
                  </label>
                  <input
                    type="text"
                    value={formBanco.codigo_banco}
                    onChange={(e) => setFormBanco({ ...formBanco, codigo_banco: e.target.value })}
                    placeholder="Ex: bancoSantander"
                    required
                    style={{
                      width: '100%',
                      padding: '0.75rem',
                      border: '1px solid #ddd',
                      borderRadius: '6px',
                      fontSize: '1rem',
                      background: 'white'
                    }}
                  />
                  <small style={{ color: '#666', marginTop: '5px', display: 'block' }}>
                    {bancoEditando 
                      ? '⚠️ Atenção: Esta é a chave usada para sincronizar com o sistema desktop' 
                      : '💡 Você pode usar um código padrão (veja o ícone ?) ou criar uma chave personalizada'}
                  </small>
                </div>

                <div style={{ marginBottom: '1.5rem' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10 }}>
                    <label style={{ fontWeight: '600', color: '#333' }}>Logins do banco</label>
                    <button type="button" className="btn-secondary" onClick={adicionarAcessoBanco}>+ Adicionar login</button>
                  </div>
                  {!formBanco.acessos?.length && <div style={{ padding: 12, border: '1px dashed #cbd5e1', borderRadius: 8, color: '#64748b', fontSize: 13 }}>Nenhum login cadastrado.</div>}
                  <div style={{ display: 'grid', gap: 10 }}>
                    {(formBanco.acessos || []).map((acesso, indice) => (
                      <div key={acesso._id || indice} style={{ padding: 12, border: `1px solid ${acesso.principal ? '#60a5fa' : '#dbe3ec'}`, borderRadius: 8, background: acesso.principal ? '#eff6ff' : '#fff' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>
                          <input type="radio" name="acesso-principal-banco" checked={Boolean(acesso.principal)} onChange={() => selecionarAcessoPrincipal(indice)} />
                          <span style={{ fontSize: 13, fontWeight: 700 }}>{acesso.principal ? 'Login principal (enviado via API)' : 'Definir como principal'}</span>
                          <button type="button" onClick={() => removerAcessoBanco(indice)} style={{ marginLeft: 'auto', border: 0, background: 'transparent', color: '#dc2626', cursor: 'pointer' }}>Excluir</button>
                        </div>
                        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
                          <input type="text" value={acesso.nome || ''} onChange={e => atualizarAcessoBanco(indice, 'nome', e.target.value)} placeholder="Identificação (ex: João)" style={{ padding: 10, border: '1px solid #cbd5e1', borderRadius: 6 }} />
                          <input type="text" value={acesso.login || ''} onChange={e => atualizarAcessoBanco(indice, 'login', e.target.value)} placeholder="Login" style={{ padding: 10, border: '1px solid #cbd5e1', borderRadius: 6 }} />
                          <input type={mostrarSenhaBanco ? 'text' : 'password'} value={acesso.senha || ''} onChange={e => atualizarAcessoBanco(indice, 'senha', e.target.value)} placeholder="Senha" style={{ gridColumn: '1 / -1', padding: 10, border: '1px solid #cbd5e1', borderRadius: 6 }} />
                        </div>
                      </div>
                    ))}
                  </div>
                  {formBanco.acessos?.length > 0 && <button type="button" onClick={() => setMostrarSenhaBanco(!mostrarSenhaBanco)} style={{ marginTop: 8, border: 0, background: 'transparent', color: '#2563eb', cursor: 'pointer' }}>{mostrarSenhaBanco ? 'Ocultar senhas' : 'Mostrar senhas'}</button>}
                </div>

                <div style={{ display: 'flex', gap: '1rem', justifyContent: 'space-between', marginTop: '2rem' }}>
                  {bancoEditando && (
                    <button
                      type="button"
                      onClick={() => {
                        excluirBanco(bancoEditando._id);
                        fecharModalBanco();
                      }}
                      style={{
                        padding: '0.75rem 1.5rem',
                        background: '#e74c3c',
                        color: 'white',
                        border: 'none',
                        borderRadius: '6px',
                        cursor: 'pointer',
                        fontSize: '1rem',
                        fontWeight: '600'
                      }}
                    >
                      🗑️ Excluir
                    </button>
                  )}
                  <div style={{ display: 'flex', gap: '1rem', marginLeft: 'auto' }}>
                    <button
                      type="submit"
                      disabled={loading || (user?.tipo === 'super_admin' && !lojaContexto)}
                      style={{
                        padding: '0.75rem 1.5rem',
                        background: bancoEditando ? '#3498db' : '#27ae60',
                        color: 'white',
                        border: 'none',
                        borderRadius: '6px',
                        cursor: loading || (user?.tipo === 'super_admin' && !lojaContexto) ? 'not-allowed' : 'pointer',
                        fontSize: '1rem',
                        fontWeight: '600',
                        opacity: loading || (user?.tipo === 'super_admin' && !lojaContexto) ? 0.6 : 1
                      }}
                    >
                      {loading ? '⏳ Salvando...' : (bancoEditando ? '💾 Atualizar' : '✅ Cadastrar')}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        )}
        
        {/* Modal de Referência de Bancos Padrão */}
        {showTabelaBancosReferencia && (
          <div 
            style={{
              position: 'fixed',
              inset: 0,
              background: 'rgba(0,0,0,0.55)',
              backdropFilter: 'blur(4px)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              zIndex: 3500,
              padding: '18px'
            }}
            onClick={() => setShowTabelaBancosReferencia(false)}
          >
            <div
              style={{
                background: '#ffffff',
                border: '1px solid #e5e7eb',
                borderRadius: '14px',
                width: 'min(600px, 95vw)',
                maxHeight: '85vh',
                display: 'flex',
                flexDirection: 'column',
                overflow: 'hidden',
                boxShadow: '0 18px 48px rgba(0,0,0,0.25)'
              }}
              onClick={(e) => e.stopPropagation()}
            >
              <div
                style={{
                  padding: '18px 20px',
                  background: '#3498db',
                  color: '#ffffff',
                  borderBottom: '1px solid #e5e7eb',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between'
                }}
              >
                <h3 style={{ margin: 0, fontSize: '1.2rem', fontWeight: '700' }}>
                  📋 Tabela de Referência - Bancos Padrão
                </h3>
                <button
                  onClick={() => setShowTabelaBancosReferencia(false)}
                  style={{
                    background: 'none',
                    border: 'none',
                    cursor: 'pointer',
                    fontSize: '1.5rem',
                    color: '#ffffff',
                    padding: '0',
                    width: '30px',
                    height: '30px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}
                >
                  ×
                </button>
              </div>
              
              <div style={{ 
                overflowY: 'auto', 
                flex: 1, 
                padding: '20px'
              }}>
                <p style={{ color: '#666', marginBottom: '1rem', fontSize: '0.95rem' }}>
                  Use as chaves de sincronização abaixo para criar bancos com identificadores padrão. 
                  Você também pode criar chaves personalizadas digitando uma nova identificação.
                </p>
                
                <table style={{
                  width: '100%',
                  borderCollapse: 'collapse',
                  fontSize: '0.95rem'
                }}>
                  <thead>
                    <tr style={{ background: '#f3f4f6', borderBottom: '2px solid #3498db' }}>
                      <th style={{ 
                        padding: '12px', 
                        textAlign: 'left', 
                        fontWeight: '700', 
                        color: '#333'
                      }}>
                        Banco
                      </th>
                      <th style={{ 
                        padding: '12px', 
                        textAlign: 'left', 
                        fontWeight: '700', 
                        color: '#333'
                      }}>
                        Chave de Sincronização
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {BANCOS_PADRAO.map((banco, idx) => (
                      <tr 
                        key={banco.id}
                        style={{ 
                          borderBottom: '1px solid #e5e7eb',
                          background: idx % 2 === 0 ? '#ffffff' : '#f9fafb',
                          transition: 'background-color 0.2s',
                          cursor: 'pointer'
                        }}
                        onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#e3f2fd'}
                        onMouseLeave={(e) => e.currentTarget.style.backgroundColor = idx % 2 === 0 ? '#ffffff' : '#f9fafb'}
                      >
                        <td style={{ padding: '12px', color: '#333' }}>
                          {banco.nome}
                        </td>
                        <td style={{ padding: '12px', color: '#666' }}>
                          <code style={{
                            background: '#f0f0f0',
                            padding: '4px 8px',
                            borderRadius: '4px',
                            fontFamily: 'monospace',
                            fontSize: '0.9rem',
                            wordBreak: 'break-word'
                          }}>
                            {banco.id}
                          </code>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        )}
        
        {message && (
          <div className={`message ${message.type}`}>
            {message.text}
          </div>
        )}

        {iaModal.aberto && (
          <div
            style={{
              position: 'fixed',
              inset: 0,
              background: 'rgba(0,0,0,0.55)',
              backdropFilter: 'blur(4px)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              zIndex: 3500,
              padding: '18px'
            }}
          >
            <div
              style={{
                background: '#ffffff',
                border: '1px solid #e5e7eb',
                borderRadius: '14px',
                width: 'min(760px, 95vw)',
                maxHeight: '92vh',
                display: 'flex',
                flexDirection: 'column',
                overflow: 'hidden',
                boxShadow: '0 18px 48px rgba(0,0,0,0.25)',
                color: '#1f2937'
              }}
            >
              <div
                style={{
                  padding: '14px 16px',
                  background: iaModal.erro
                    ? 'linear-gradient(135deg, #e74c3c 0%, #c0392b 100%)'
                    : '#ffffff',
                  color: iaModal.erro ? '#ffffff' : '#c14427',
                  borderBottom: '1px solid #e5e7eb',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  gap: '12px'
                }}
              >
                <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                  <div style={{ fontSize: '15px', fontWeight: 800, letterSpacing: '0.3px', color: iaModal.erro ? '#ffffff' : '#c14427' }}>{iaModal.titulo || 'Ferramentas IA'}</div>
                  {iaModal.veiculo && (
                    <div style={{
                      display: 'inline-flex',
                      alignItems: 'center',
                      gap: '8px',
                      background: iaModal.erro ? 'rgba(255,255,255,0.2)' : 'rgba(193,68,39,0.12)',
                      borderRadius: '999px',
                      padding: '6px 12px',
                      fontSize: '12px',
                      fontWeight: 600
                    }}>
                      <span style={{ fontSize: '12px' }}>🚗</span>
                      <span>{iaModal.veiculo.marca} {iaModal.veiculo.modelo}</span>
                    </div>
                  )}
                </div>
                <button
                  onClick={fecharModalIA}
                  style={{
                    background: iaModal.erro ? 'rgba(255,255,255,0.2)' : 'rgba(0,0,0,0.04)',
                    border: iaModal.erro ? '1px solid rgba(255,255,255,0.35)' : '1px solid #e5e7eb',
                    color: iaModal.erro ? '#ffffff' : '#4b5563',
                    width: '36px',
                    height: '36px',
                    borderRadius: '10px',
                    cursor: 'pointer',
                    fontSize: '18px',
                    transition: 'all 0.2s ease'
                  }}
                  onMouseEnter={(e) => e.currentTarget.style.background = iaModal.erro ? 'rgba(255,255,255,0.3)' : '#f3f4f6'}
                  onMouseLeave={(e) => e.currentTarget.style.background = iaModal.erro ? 'rgba(255,255,255,0.2)' : 'rgba(0,0,0,0.04)'}
                  type="button"
                >
                  ✕
                </button>
              </div>

              <div
                style={{
                  padding: '18px',
                  overflowY: 'auto',
                  lineHeight: 1.55,
                  fontSize: '14px',
                  color: '#1f2937',
                  background: '#f8fafc'
                }}
              >
                <div style={{ display: 'grid', gap: '14px' }}>
                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: '12px', alignItems: 'flex-end' }}>
                    <div style={{ display: 'flex', flexDirection: 'column', minWidth: '200px', flex: 1 }}>
                      <label style={{ fontWeight: 700, marginBottom: '8px', color: '#c14427', letterSpacing: '0.2px' }}>Ferramenta</label>
                      <select
                        value={iaModal.tipo}
                        onChange={(e) => setIaModal((prev) => ({
                          ...prev,
                          tipo: e.target.value,
                          conteudo: '',
                          loading: false,
                          erro: false,
                          titulo: 'Ferramentas IA'
                        }))}
                        style={{
                          padding: '12px 14px',
                          border: '1px solid #d1d5db',
                          borderRadius: '12px',
                          fontWeight: 700,
                          color: '#1f2937',
                          background: '#ffffff',
                          outline: 'none',
                          minWidth: '200px',
                          boxShadow: '0 6px 18px rgba(0,0,0,0.05)'
                        }}
                      >
                        <option value="apresentacao">Apresentação</option>
                        <option value="confronto">Confronto</option>
                      </select>
                    </div>

                    {iaModal.tipo === 'confronto' && (
                      <div style={{ display: 'flex', flexDirection: 'column', flex: 2, minWidth: '240px' }}>
                        <label style={{ fontWeight: 700, marginBottom: '8px', color: '#c14427', letterSpacing: '0.2px' }}>Modelo para confronto</label>
                        <input
                          type="text"
                          value={iaModal.modeloComparacao}
                          onChange={(e) => setIaModal((prev) => ({ ...prev, modeloComparacao: e.target.value }))}
                          placeholder="Ex: Corolla 2020"
                          style={{
                            padding: '12px 14px',
                            border: '1px solid #d1d5db',
                            borderRadius: '12px',
                            fontWeight: 600,
                            color: '#1f2937',
                            background: '#ffffff',
                            outline: 'none',
                            boxShadow: '0 6px 18px rgba(0,0,0,0.05)'
                          }}
                        />
                      </div>
                    )}

                    <button
                      type="button"
                      onClick={gerarConteudoIA}
                      disabled={iaModal.loading}
                      style={{
                        background: '#c14427',
                        color: '#ffffff',
                        border: 'none',
                        borderRadius: '10px',
                        padding: '12px 16px',
                        fontWeight: 800,
                        minWidth: '140px',
                        boxShadow: '0 12px 28px rgba(193,68,39,0.32)',
                        cursor: iaModal.loading ? 'not-allowed' : 'pointer',
                        opacity: iaModal.loading ? 0.85 : 1,
                        transition: 'transform 0.12s ease, box-shadow 0.22s ease'
                      }}
                      onMouseEnter={(e) => {
                        if (!iaModal.loading) {
                          e.currentTarget.style.transform = 'translateY(-1px)';
                          e.currentTarget.style.boxShadow = '0 14px 30px rgba(193,68,39,0.42)';
                        }
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = 'none';
                        e.currentTarget.style.boxShadow = '0 12px 28px rgba(193,68,39,0.32)';
                      }}
                    >
                      {iaModal.loading ? 'Gerando...' : 'Gerar'}
                    </button>
                  </div>

                  <div style={{ display: 'flex', gap: '10px', justifyContent: 'center', alignItems: 'center', flexWrap: 'wrap' }}>
                    <button
                      type="button"
                      onClick={copiarConteudoIA}
                      disabled={!iaModal.conteudo}
                      style={{
                        background: '#27ae60',
                        color: '#ffffff',
                        border: 'none',
                        borderRadius: '10px',
                        padding: '11px 14px',
                        fontWeight: 700,
                        cursor: iaModal.conteudo ? 'pointer' : 'not-allowed',
                        opacity: iaModal.conteudo ? 1 : 0.6,
                        boxShadow: '0 10px 24px rgba(39,174,96,0.22)'
                      }}
                    >
                      Copiar
                    </button>
                  </div>

                  <div
                    style={{
                      border: '1px solid ' + (iaModal.erro ? '#f5c2c7' : '#e5e7eb'),
                      background: iaModal.erro ? '#fef2f2' : '#ffffff',
                      borderRadius: '12px',
                      padding: '16px',
                      minHeight: '220px',
                      whiteSpace: 'pre-wrap',
                      color: iaModal.erro ? '#b91c1c' : '#1f2937',
                      boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.6)'
                    }}
                  >
                    {iaModal.loading
                      ? 'Gerando resposta da IA...'
                      : (iaModal.conteudo || 'Escolha uma ferramenta, ajuste os parâmetros e clique em Gerar.')}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Modal Histórico de Removidos */}
        {showHistoricoRemovidos && (
          <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'rgba(0,0,0,0.5)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 9999
          }}>
            <div style={{
              background: 'white',
              borderRadius: '12px',
              padding: '24px',
              maxWidth: '900px',
              width: '90%',
              maxHeight: '85vh',
              display: 'flex',
              flexDirection: 'column',
              boxShadow: '0 20px 60px rgba(0,0,0,0.3)'
            }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                <h2 style={{ margin: 0, fontSize: '1.8rem', color: '#2d3748' }}>
                  📋 Histórico de Veículos Removidos
                </h2>
                <button
                  onClick={() => setShowHistoricoRemovidos(false)}
                  style={{
                    background: '#e74c3c',
                    color: 'white',
                    border: 'none',
                    borderRadius: '6px',
                    width: '40px',
                    height: '40px',
                    fontSize: '1.2rem',
                    cursor: 'pointer'
                  }}
                >
                  ✕
                </button>
              </div>

              {/* Campo de Pesquisa */}
              <div style={{ marginBottom: '15px' }}>
                <input
                  type="text"
                  placeholder="Pesquisar por placa..."
                  value={searchRemovidos}
                  onChange={(e) => {
                    setSearchRemovidos(e.target.value);
                    carregarRemovidos(e.target.value);
                  }}
                  style={{
                    width: '100%',
                    padding: '12px',
                    border: '2px solid #3498db',
                    borderRadius: '6px',
                    fontSize: '1rem'
                  }}
                />
              </div>

              {/* Lista de Removidos */}
              <div style={{ flex: 1, overflowY: 'auto', border: '1px solid #ddd', borderRadius: '8px', padding: '15px' }}>
                {loadingRemovidos ? (
                  <div style={{ textAlign: 'center', padding: '40px', color: '#666' }}>
                    ⏰ Carregando...
                  </div>
                ) : veiculosRemovidos.length === 0 ? (
                  <div style={{ textAlign: 'center', padding: '40px', color: '#999' }}>
                    Nenhum veículo removido encontrado
                  </div>
                ) : (
                  <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                    <thead>
                      <tr style={{ borderBottom: '2px solid #3498db', background: '#ecf0f1' }}>
                        <th style={{ padding: '12px', textAlign: 'left', fontWeight: '600' }}>Placa</th>
                        <th style={{ padding: '12px', textAlign: 'left', fontWeight: '600' }}>Veículo</th>
                        <th style={{ padding: '12px', textAlign: 'left', fontWeight: '600' }}>Ano</th>
                        <th style={{ padding: '12px', textAlign: 'right', fontWeight: '600' }}>Ações</th>
                      </tr>
                    </thead>
                    <tbody>
                      {veiculosRemovidos.map((veiculo) => (
                        <tr key={veiculo._id} style={{ borderBottom: '1px solid #ddd' }}>
                          <td style={{ padding: '12px', fontWeight: '600', color: '#e74c3c' }}>
                            {veiculo.placa || '-'}
                          </td>
                          <td style={{ padding: '12px' }}>
                            {veiculo.marca} {veiculo.modelo}
                          </td>
                          <td style={{ padding: '12px' }}>
                            {veiculo.ano_modelo || '-'}
                          </td>
                          <td style={{ padding: '12px', textAlign: 'right' }}>
                            <button
                              onClick={() => restaurarVeiculo(veiculo._id)}
                              style={{
                                background: '#27ae60',
                                color: 'white',
                                border: 'none',
                                borderRadius: '6px',
                                padding: '8px 12px',
                                cursor: 'pointer',
                                fontSize: '0.9rem',
                                fontWeight: '600'
                              }}
                              title="Restaurar veículo"
                            >
                              ↻ Restaurar
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                )}
              </div>

              {/* Total */}
              <div style={{ marginTop: '15px', textAlign: 'right', color: '#666', fontSize: '0.95rem' }}>
                Total de removidos: <strong>{veiculosRemovidos.length}</strong>
              </div>
            </div>
          </div>
        )}

      </div>
    </div>
  );
};

export default Dashboard;
